<template>
  <div class="row" style="min-height: 74vh;">
    <div class="col-1"></div>
    <div class="col-10 mt-4">
      <div class="row">
        <div class="card col-12 mb-3 mt-3">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-12 pe-1 mt-1">
              <div class="card-body text-start">
                <span class="card-title fw-bold" style="font-size: 1rem"> <i class="icon-users"/> HR Personel Management </span>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12">
              <div class="card-body text-end "
                   v-isadminpermcheck="'Hr_PersonelManagement.HR_UserPermManagementGrids.W'">
                <button class="col-12 btn btn-outline-default" data-bs-toggle="modal" data-bs-target="#permissionModal">
                  <span class="mx-1">Add Permission</span>
                </button>
              </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12"
                 v-if="this.personCheckInputForm.documentType !== 'General' && this.personCheckInputForm.Id !== ''">
              <div class="card-body text-end">
                <button class="col-12 btn btn-outline-default" @click="btnCreate()">
                  <span class="mx-1">New {{ btnCreateLabel }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-permcheck="'Hr_PersonelManagement.Hr_PersonelManagement.R'">
          <div class="row">
            <div class="col-sm-12 col-md-7 col-lg-7">
              <div class="pt-2">
                <div class="card col-12 mb-1">
                  <div class="row">
                    <div class="col-10">
                      <div class="m-2 col-md-8 col-sm-12 d-flex">
                        <div class="input-group pe-3">
                          <input class="form-control" required maxlength="50" placeholder="Search"
                                 v-model="search">
                        </div>
                        <div class="input-group pe-3">
                          <input class="form-control" required maxlength="3" placeholder="Search By TLC"
                                 v-model="searchTLC">
                        </div>
                        <!-- <div class="input-group d-flex">
                          <span style="line-height: 3;" class="me-3">Report: </span>
                          <select class="p-1 rounded" @change="getReport()" v-model="selectedValue">
                            <option selected="selected" disabled>Select</option>
                            <option>Pasaport</option>
                            <option>Visa</option>
                            <option>License</option>
                            <option>Medical</option>
                            <option>Landing</option>
                          </select>
                        </div> -->
                      </div>
                    </div>
                    <div class="col-2 align-self-center text-end pe-1">
                      <!--                      <i data-bs-toggle="tooltip" data-bs-placement="bottom" title="Info Popup"-->
                      <!--                         class="icon-info me-2 text-warning"/>-->
                      <div class="icon-info me-2 text-warning tooltip">
                        <div class="bottom">
                          <h5>Passaport Document Stats</h5>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #8cc3a9"></div>
                            <p class="col-10">Last 14 months before expiry date </p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ffe083"></div>
                            <p class="col-10">14 months before expiry date </p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ffe083"></div>
                            <p class="col-10">12 months before expiry date </p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ed9aa2"></div>
                            <p class="col-10">11 months before expiry date </p>
                          </div>
                          <h5>Medical Check Document Stats</h5>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #8cc3a9"></div>
                            <p class="col-10">Last 3 Months before expiry date </p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ffe083"></div>
                            <p class="col-10">3 Months before expiry date </p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ffe083"></div>
                            <p class="col-10">2 Months before expiry date </p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ed9aa2"></div>
                            <p class="col-10">1 Month before expiry date </p>
                          </div>
                          <h5>Licence Document Stats</h5>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #8cc3a9"></div>
                            <p class="col-10">Last 3 Months before expiry date</p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ffe083"></div>
                            <p class="col-10">3 Months before expiry date </p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ffe083"></div>
                            <p class="col-10">2 Months before expiry date </p>
                          </div>
                          <div class="row col-12">
                            <div class="status col-2 me-2 mt-1" style="background-color: #ed9aa2"></div>
                            <p class="col-10">1 Month before expiry date </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="card table-responsive tableFixHead" style="max-height: 530px">
                  <table class="table table-striped align-middle "
                         style="overflow-x: auto; overflow-y: auto">
                    <thead>
                    <tr>
                      <th style="background-color: rgb(86, 117, 156); color: white">STAT</th>
                      <th style="background-color: rgb(86, 117, 156); color: white">EMP ID</th>
                      <th style="background-color: rgb(86, 117, 156); color: white"
                          v-for="(column,index) in headers"
                          :key="index">{{ column.toUpperCase() }}
                      </th>
                      <th style="background-color: rgb(86, 117, 156); color: white">BIRTHDATE</th>
                      <th style="background-color: rgb(86, 117, 156); color: white">EMP STAT</th>

                    </tr>
                    </thead>
                    <tbody v-if="personelList != [] ">
                    <tr v-for="(row,index) in filteredData" :key="index">
                      <td @click="getDataById(row)" style="color: #454543; cursor: pointer; text-align: -webkit-center">
                        <div class="status" :style="{background: statusColor(row.STAT_General)}"></div>
                      </td>
                      <td @click="getDataById(row)" style="color: #454543; cursor: pointer">{{ row.Identitydef }}</td>
                      <td @click="getDataById(row)" style="color: #454543; cursor: pointer"
                          v-for="(column, index) in headers" :key="index">{{ row[column] }}
                      </td>
                      <td @click="getDataById(row)" style="color: #454543; cursor: pointer">
                        {{ new Date(row.Birthdate).toLocaleDateString() }}
                      </td>
                      <td @click="getDataById(row)" style="color: #454543; cursor: pointer">
                        {{ new Date(row.EMP_START).toLocaleDateString() }}
                      </td>

                    </tr>
                    </tbody>
                    <tbody v-if="personelList == [] ">
                    <tr>
                      <td :colspan="headers.length+1" style="color: #454543">
                        <a style="color: #454543">
                          <span class="card-title fw-bold">No Data</span>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-5 col-lg-5 gx-2 mt-2">
              <div class="border rounded-2" style="padding: 10px" v-if="personelList.length != 0"
                   v-permcheck="'Hr_PersonelManagement.Hr_PersonelManagement.W'">
                <h6 class="row justify-content-center"
                    style="padding: 5px;color: rgb(86, 117, 156);border-bottom:2px solid rgb(86, 117, 156);font-size: 0.8rem"
                    v-if="!isCreated">
                  <i class="icon-user me-2"/>
                  You are editing user {{ personCheckInputForm.name.toUpperCase() }}
                  {{ personCheckInputForm.surname.toUpperCase() }}
                </h6>
                <div class="row" style="padding: 5px;border-bottom: 1px solid black;">
                  <div class="col-12">
                    <ul class="nav nav-tabs">
                      <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="pill"
                           href="#general"
                           @click="changeDocumentTypeByID('General')">
                          General</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="pill"
                           @click="changeDocumentTypeByID('Passport', 1)"
                           href="#passport">
                          <div class="row w-100">
                            <div class="col-2" style="height: 15px; width: 5px;"
                                 :style="{ background: statusColor(passportInputForm.stat) }"></div>
                            <div class="col-10 ps-1">Pasaport</div>
                          </div>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="pill" href="#visa"
                           @click="changeDocumentTypeByID('Visa', 2)">
                          <div class="row w-100">
                            <div class="col-2" style="height: 15px; width: 5px;"
                                 :style="{ background: statusColor(visaInputForm.stat) }"></div>
                            <div class="col-10 ps-1">Visa</div>
                          </div>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="pill" href="#license"
                           @click="changeDocumentTypeByID('License Information', 3)">
                          <div class="row w-100">
                            <div class="col-2" style="height: 15px; width: 5px;"
                                 :style="{ background: statusColor(licenseInformationInputForm.stat) }"></div>
                            <div class="col-10 ps-1">License</div>
                          </div>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="pill" href="#medical" style="width: 135px"
                           @click="changeDocumentTypeByID('Medical Check', 4)">
                          <div class="row w-100 justify-content-center">
                            <div class="col-2" style="height: 15px; width: 5px;"
                                 :style="{ background: statusColor(medicalCheckInputForm.stat) }"></div>
                            <div class="col-10 ps-1">Medical Check</div>
                          </div>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="pill"
                           href="#landing"
                           @click="changeDocumentTypeByID('Landing Information', 5)">
                          <div class="row w-100">
                            <div class="col-2" style="height: 15px; width: 5px;"
                                 :style="{ background: statusColor(landingInformationInputForm.stat) }"></div>
                            <div class="col-10 ps-1">Landing</div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="col-12" v-if="!isCreated">
                    <div class="col-12 mt-2"
                         v-if="(medicalCheckInformation != null || medicalCheckInformation != [])">
                      <ul class="nav nav-pills"
                          v-if="personCheckInputForm.documentType == 'Medical Check'">
                        <li class="nav-item"
                            v-for="(medical, index,k) in medicalCheckInformation"
                            :key="index">
                          <a class="nav-link"
                             :class="{ 'active' : tabIndex != null && k == 0 }"
                             data-bs-toggle="pill"
                             href=""
                             id="nav2"
                             @click="getMedicalCheckInputDataByIndex(k, medical)">MC
                            {{ ++k }}</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 mt-2"
                         v-if="(passportInformation != null || passportInformation != [])">
                      <ul class="nav nav-pills"
                          v-if="personCheckInputForm.documentType == 'Passport'">
                        <li class="nav-item" v-for="(passport, index,k) in passportInformation"
                            :key="index">
                          <!--                             :class="[post.iS_DELETED == 1 && ShowDeletedFlights == true? 'strikeout': '', (post.iS_DELETED == 1 && ShowDeletedFlights == false) ? 'hideDeletedFlight':'',(post.iS_AIRCRAFT_USED == false && showRelatedAircrafts == true )? 'hideDeletedFlight' : '']" >-->
<!--                          :class="{ 'active' : tabIndex == 0 && k == 0 }"-->

                          <a class="nav-link"
                             :class="{ 'active' : tabIndex == 0 && k == 0 }"
                             data-bs-toggle="pill"
                             href=""
                             @click="getPassportInputDataByIndex(--k, passport)">P
                            {{ ++k }}</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 mt-2"
                         v-if=" (visaInformation != null || visaInformation != [])">
                      <ul class="nav nav-pills"
                          v-if="personCheckInputForm.documentType == 'Visa'">
                        <li class="nav-item" v-for="(visa, index,k) in visaInformation"
                            :key="index">
                          <!--                          RENK OLARAK GÜNCELLEME YAPILACAK-->
                          <a class="nav-link"
                             :class="{ 'active' : tabIndex == 0 && k == 0 }"
                             data-bs-toggle="pill"
                             href=""
                             @click="getVisaInputDataByIndex(--index, visa)">V
                            {{ ++k }}</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 mt-2"
                         v-if="(licenceInformation != null || licenceInformation != [])">
                      <ul class="nav nav-pills"
                          v-if="personCheckInputForm.documentType == 'License Information'">
                        <li class="nav-item" id="nav" v-for="(license, index,k) in licenceInformation"
                            :key="index">
                          <a class="nav-link"
                             :class="{ 'active' : tabIndex == 0 && k == 0 }"
                             data-bs-toggle="pill"
                             href=""
                             @click="getLicenseInputDataByIndex(--index, license)">LI
                            {{ ++k }}</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12 mt-2"
                         v-if="(landingInformation != null || landingInformation != [])">
                      <ul class="nav nav-pills"
                          v-if="personCheckInputForm.documentType == 'Landing Information'">
                        <li class="nav-item" v-for="(landing, index,k) in landingInformation"
                            :key="index">
                          <a class="nav-link"
                             :class="{ 'active' : tabIndex == 0 && k == 0 }"
                             data-bs-toggle="pill"
                             href=""
                             id="nav"
                             @click="getLandingInputDataByIndex(--index, landing)">LD
                            {{ ++k }}</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-12" v-if="isCreatedBtn">
                      <div class="alert alert-warning d-flex align-items-center justify-content-center" role="alert">
                        <div>
                          You are creating new {{ btnCreateLabel }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pt-2" style="border-top: 1px solid #f3f3f3;padding: 10px">
                  <div class="row col-12">
                    <div class="tab-content">
                      <div class="tab-pane m-0 p-0 active" id="general">
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Name</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control" disabled
                                     v-model="personCheckInputForm.name">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Surname</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control" disabled
                                     v-model="personCheckInputForm.surname">
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">TLC</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control" disabled
                                     v-model="personCheckInputForm.tlc">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Birthdate</label>
                            </div>
                            <div class="input-group">
                              <date-picker class="form-control noselect" v-model="personCheckInputForm.birtdate"
                                           type="date" value-type="YYYY-MM-DD" format="DD-MM-YYYY" placeholder="Date"
                                           :clearable="false" :editable="false" disabled></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Gender</label>
                            </div>
                            <div class="input-group">
                              <select class="form-select" disabled
                                      v-model="personCheckInputForm.gender"
                                      style="font-size: 14px">
                                <option v-for="(gender,index) in this.genders"
                                        :value="gender.value" :key="index">{{
                                    gender.gender
                                  }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Identity</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control" disabled
                                     v-model="personCheckInputForm.identity">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Email</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control" disabled
                                     v-model="personCheckInputForm.mail">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Company</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control" disabled
                                     v-model="personCheckInputForm.CompanyCode">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="m-0 p-0 tab-pane fade" id="medical">
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2"
                               v-if="this.personCheckInputForm.rank == 0 || this.personCheckInputForm.rank == 1">
                            <div class="input-group">
                              <label class="form-label pt-2">Medical Check Type</label>
                            </div>
                            <div class="input-group">
                              <div class="col-sm-12 col-md-6 col-lg-6 ps-2 text-start">
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio"
                                         name="MedicalCheckType"
                                         id="MedicalCheckTypeTR" value="TR"
                                         v-model="medicalCheckInputForm.type">
                                  <label class="form-check-label"
                                         style="margin-top: 3px"
                                         for="MedicalCheckTypeTR">TR</label>
                                </div>
                              </div>
                              <div class="col-sm-12 col-md-6 col-lg-6 ps-2 text-start">
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio"
                                         name="MedicalCheckType"
                                         id="MedicalCheckTypeEASA" value="EASA"
                                         v-model="medicalCheckInputForm.type">
                                  <label class="form-check-label"
                                         style="margin-top: 3px"
                                         for="MedicalCheckTypeEASA">EASA</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2"
                               v-show="this.personCheckInputForm.rank == 0 || this.personCheckInputForm.rank == 1">
                            <div class="input-group">
                              <label class="form-label pt-2">CVL Type</label>
                            </div>
                            <div class="input-group">
                              <div class="col-sm-12 col-md-12 col-lg-12 text-start">
                                <div class="input-group">
                                  <multiselect v-model="multiSelectValue"
                                               tag-placeholder="Add this as new tag"
                                               placeholder="Search or add a tag"
                                               :options="multiSelectOptions"
                                               :multiple="true" :taggable="true"
                                               @tag="addTag"></multiselect>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Date of issue</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="medicalCheckInputForm.dateOfIssue">-->
                              <date-picker class="form-control" v-model="medicalCheckInputForm.dateOfIssue" type="date"
                                           value-type="YYYY-MM-DD" format="DD-MM-YYYY" placeholder="Date"></date-picker>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Date of expiry</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="medicalCheckInputForm.dateOfExpiry">-->
                              <date-picker class="form-control" v-model="medicalCheckInputForm.dateOfExpiry" type="date"
                                           value-type="YYYY-MM-DD" format="DD-MM-YYYY" placeholder="Date"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">CVL Description</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="medicalCheckInputForm.CVL_DESCRIPTION">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Licence Type</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="medicalCheckInputForm.LICENCE_TYPE">
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Licence NO</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="medicalCheckInputForm.LICENCE_NO">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="m-0 p-0 tab-pane fade" id="passport">
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Passport NR</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="passportInputForm.passportNR" @keydown.space.prevent>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Date of issue</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="passportInputForm.dateOfIssue">-->
                              <date-picker class="form-control" v-model="passportInputForm.dateOfIssue" type="date"
                                           value-type="YYYY-MM-DD" format="DD-MM-YYYY" placeholder="Date"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Country of issue</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="passportInputForm.countryOfIssue">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Place of issue</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="passportInputForm.placeOfIssue">
                            </div>
                          </div>
                          <!--                                                    <CustomInput label="Country of issue"-->
                          <!--                                                                 v-model="passportInputForm.countryOfIssue"/>-->
                          <!--                                                    &lt;!&ndash;                          2&ndash;&gt;-->
                          <!--                                                    <CustomInput label="Place of issue"-->
                          <!--                                                                 v-model="passportInputForm.placeOfIssue"/>-->
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Date of expiry</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="passportInputForm.dateOfExpiry">-->
                              <date-picker class="form-control" v-model="passportInputForm.dateOfExpiry" type="date"
                                           value-type="YYYY-MM-DD" format="DD-MM-YYYY" placeholder="Date"></date-picker>
                            </div>
                          </div>
                          <!--                                                    <CustomInput label="Date of expiry" type="date"-->
                          <!--                                                                 v-model="passportInputForm.dateOfExpiry"/>-->
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Nationality</label>
                            </div>
                            <div class="input-group">
                              <div class="col-sm-12 col-md-12 col-lg-12 text-start">
                                <div class="input-group">
                                  <multiselect v-model="nationalityOptionsValue"
                                               tag-placeholder="Add this as new tag"
                                               placeholder="Search or add a tag"
                                               :custom-label="nameWithLang"
                                               :options="nationalityOptions"
                                               :multiple="false" :taggable="true"
                                               :allow-empty="false"
                                               @tag="addTag"></multiselect>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="m-0 p-0 tab-pane fade" id="visa">
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Passport NR</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="visaInputForm.passportNR" @keydown.space.prevent>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Country</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control" v-model="visaInputForm.country">
                            </div>
                          </div>
                          <!--                                                    <CustomInput label="Passport NR"-->
                          <!--                                                                 v-model="visaInputForm.passportNR"/>-->
                          <!--                                                    <CustomInput label="Country" v-model="visaInputForm.country"/>-->
                          <!--                          3-->
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Date of issue</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="visaInputForm.dateOfIssue">-->
                              <date-picker class="form-control" v-model="visaInputForm.dateOfIssue" type="date"
                                           value-type="YYYY-MM-DD" format="DD-MM-YYYY" placeholder="Date"></date-picker>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Date of expiry</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="visaInputForm.dateOfExpiry">-->
                              <date-picker class="form-control" v-model="visaInputForm.dateOfExpiry" type="date"
                                           value-type="YYYY-MM-DD" format="DD-MM-YYYY" placeholder="Date"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Place of issue</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="visaInputForm.placeOfIssue">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Visa NR</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control" v-model="visaInputForm.visaNR">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="m-0 p-0 tab-pane fade" id="license">
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Licence Type</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.licenseType">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">License Number</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.licenseNumber">
                            </div>
                          </div>
                          <!--                                                    <CustomInput label="Licence Type"-->
                          <!--                                                                 v-model="licenseInformationInputForm.licenseType"/>-->
                          <!--                                                    <CustomInput label="License Number"-->
                          <!--                                                                 v-model="licenseInformationInputForm.licenseNumber"/>-->
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Authority</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.authority">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Examiner License
                                Expiry</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="licenseInformationInputForm.examinerLicenseEmpiry">-->
                              <date-picker class="form-control"
                                           v-model="licenseInformationInputForm.examinerLicenseEmpiry" type="date"
                                           value-type="YYYY-MM-DD" format="DD-MM-YYYY" placeholder="Date"></date-picker>
                            </div>
                          </div>
                          <!--                          TEST-->
                          <!--                                                    <CustomInput label="Authority"-->
                          <!--                                                                 v-model="licenseInformationInputForm.authority"/>-->
                          <!--                                                    <CustomInput label="Issue Country"-->
                          <!--                                                                 v-model="licenseInformationInputForm.issueCountry"/>-->
                          <!--                          2-->
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">License Expiry</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="licenseInformationInputForm.licenseExpiry">-->
                              <date-picker class="form-control" v-model="licenseInformationInputForm.licenseExpiry"
                                           type="date" value-type="YYYY-MM-DD" format="DD-MM-YYYY"
                                           placeholder="Date"></date-picker>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Examiner License NR</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.examinerLicenseNR">
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Rating Certificate</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.RATING_CERTIFICATE">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Licence Title</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.LICENCE_TITLE">
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Language 1</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.LANGUAGE_1">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Language 1 Level</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.LANGUAGE_1_LEVEL">
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Language 1 Date</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="licenseInformationInputForm.LANGUAGE_1_DATE">-->
                              <date-picker class="form-control" v-model="licenseInformationInputForm.LANGUAGE_1_DATE"
                                           type="date" value-type="YYYY-MM-DD" format="DD-MM-YYYY"
                                           placeholder="Date"></date-picker>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Language 2</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.LANGUAGE_2">
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Language 2 Level</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control"
                                     v-model="licenseInformationInputForm.LANGUAGE_2_LEVEL">
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Language 2 Date</label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="licenseInformationInputForm.LANGUAGE_2_DAT">-->
                              <date-picker class="form-control" v-model="licenseInformationInputForm.LANGUAGE_2_DAT"
                                           type="date" value-type="YYYY-MM-DD" format="DD-MM-YYYY"
                                           placeholder="Date"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Issue Country</label>
                            </div>
                            <div class="input-group">
                              <input class="form-control" maxlength="2"
                                     v-model="licenseInformationInputForm.issueCountry">
                            </div>
                          </div>
                          <!--                                                    <CustomInput label="Examiner License Expiry" type="date"-->
                          <!--                                                                 v-model="licenseInformationInputForm.examinerLicenseEmpiry"/>-->
                        </div>
                      </div>
                      <div class="m-0 p-0 tab-pane fade" id="landing">
                        <div class="row col-12">
                          <div class="col-sm-12 col-md-6 col-lg-6 pe-2 ps-2">
                            <div class="input-group">
                              <label class="form-label pt-2">Expriy Date </label>
                            </div>
                            <div class="input-group">
                              <!--                              <input class="form-control" type="date"-->
                              <!--                                     v-model="landingInformationInputForm.expriyDate">-->
                              <date-picker class="form-control" v-model="landingInformationInputForm.expriyDate"
                                           type="date" value-type="YYYY-MM-DD" format="DD-MM-YYYY"
                                           placeholder="Date"></date-picker>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row gx-4 col-12 pe-2 ps-2"
                       v-if="this.personCheckInputForm.documentType !== 'General'">
                    <div class="input-group">
                      <label class="form-label pt-2">Image Upload</label>
                    </div>
                    <div class="col-3 pe-2">
                      <fieldset class="upload_dropZone text-center">
                        <file-pond name="file"
                                   id="FilePoundUpload"
                                   ref="pond"
                                   label-idle="Select Image"
                                   :files="file"
                                   :server="fileUploadLocalServer"
                                   :instant-upload="true"
                                   :drop-on-page="true"
                                   :allow-multiple="false"
                                   credits="false"
                                   accepted-file-types="image/jpeg, image/png, application/pdf"
                        />
                      </fieldset>
                      <div class="row justify-content-around">
                        <button class="col-12 btn btn-outline-default d-flex justify-content-center"
                                data-bs-toggle="modal" data-bs-target="#showModal"
                                @click="showImgBtn(0)"
                                v-if="(isShow && this.personCheckInputForm.documentType !== 'General')">
                          <i class="icon-image me-1" style="padding-top:3px;"/>
                          <span class="mx-1">Show</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-3 pe-2">
                      <fieldset class="upload_dropZone text-center">
                        <file-pond name="file"
                                   id="FilePoundUpload"
                                   ref="pond2"
                                   label-idle="Select Image"
                                   :files="file"
                                   :server="fileUploadLocalServer2"
                                   :instant-upload="true"
                                   :drop-on-page="true"
                                   :allow-multiple="false"
                                   credits="false"
                                   accepted-file-types="image/jpeg, image/png, application/pdf"
                        />
                      </fieldset>
                      <div class="row justify-content-around">
                        <button class="col-12 btn btn-outline-default d-flex justify-content-center"
                                data-bs-toggle="modal" data-bs-target="#showModal"
                                @click="showImgBtn(1)"
                                v-if="(isShow && this.personCheckInputForm.documentType !== 'General')">
                          <i class="icon-image me-1" style="padding-top:3px;"/>
                          <span class="mx-1">Show</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-3 pe-2">
                      <fieldset class="upload_dropZone text-center">
                        <file-pond name="file"
                                   id="FilePoundUpload"
                                   ref="pond3"
                                   label-idle="Select Image"
                                   :files="file"
                                   :server="fileUploadLocalServer3"
                                   :instant-upload="true"
                                   :drop-on-page="true"
                                   :allow-multiple="false"
                                   credits="false"
                                   accepted-file-types="image/jpeg, image/png, application/pdf"
                        />
                      </fieldset>
                      <div class="row justify-content-around">
                        <button class="col-12 btn btn-outline-default d-flex justify-content-center"
                                data-bs-toggle="modal" data-bs-target="#showModal"
                                @click="showImgBtn(2)"
                                v-if="(isShow && this.personCheckInputForm.documentType !== 'General')">
                          <i class="icon-image me-1" style="padding-top:3px;"/>
                          <span class="mx-1">Show</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-3">
                      <fieldset class="upload_dropZone text-center">
                        <file-pond name="file"
                                   id="FilePoundUpload"
                                   ref="pond4"
                                   label-idle="Select Image"
                                   :files="file"
                                   :server="fileUploadLocalServer4"
                                   :instant-upload="true"
                                   :drop-on-page="true"
                                   :allow-multiple="false"
                                   credits="false"
                                   accepted-file-types="image/jpeg, image/png, application/pdf"
                        />
                      </fieldset>
                      <div class="row justify-content-around">
                        <button class="col-12 btn btn-outline-default d-flex justify-content-center"
                                data-bs-toggle="modal" data-bs-target="#showModal"
                                @click="showImgBtn(3)"
                                v-if="(isShow && this.personCheckInputForm.documentType !== 'General')">
                          <i class="icon-image me-1" style="padding-top:3px;"/>
                          <span class="mx-1">Show</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row col-12 mt-2" style="border-top: 1px solid #f3f3f3">
                    <div class="col-sm-12 col-md-6 text-start">
                      <button class="col-sm-12 col-md-12 col-lg-2 col-xl-2 btn btn-outline-danger mt-3 me-2 ms-2"
                              v-if="isDeleted && this.personCheckInputForm.documentType !== 'General'"
                              @click="tryDeleteDocument(documentForm)">
                        <i class="icon-bin2"/>
                      </button>
                    </div>
                    <div class="col-sm-12 col-md-6 text-end">
                      <button class="col-sm-12 col-md-12 col-lg-5 col-xl-5 btn btn-outline-default mt-3 me-2 ms-2"
                              v-if="this.personCheckInputForm.Id !== '' && this.personCheckInputForm.documentType !== 'General'"
                              @click="tryUpdateHRPersonel()">
                        <i class="icon-floppy-disk me-1"/>
                        <span class="mx-1">Save</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="border rounded-2" style="padding: 10px" v-else>
                <div class="row" style="padding: 5px;">
                  <div class="col-12">
                    <ul class="nav nav-tabs">
                      <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="pill" href="#info">Info</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="pt-2" style="border-top: 1px solid #f3f3f3;padding: 10px">
                  <div class="row col-12">
                    <div class="tab-content">
                      <div class="tab-pane m-0 p-0 active" id="info">
                        <div class="row col-12">
                          <div class="alert alert-warning" role="alert">
                            <h4 class="alert-heading">Well done!</h4>
                            <p>Aww yeah, you successfully read this important alert message.
                              This example text is going
                              to run a bit longer so that you can see how spacing within
                              an alert works with this kind
                              of content.</p>
                            <hr>
                            <p class="mb-0">Whenever you need to, be sure to use margin
                              utilities to keep things nice
                              and tidy.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="showModal" tabindex="-1" aria-labelledby="showModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <div class="col-sm-12 col-md-6 text-start">
                <button class="col-sm-12 col-md-12 col-lg-2 col-xl-2 btn btn-outline-danger"
                        @click="tryDeleteDocumentAttachments(documentForm)">
                  <i class="icon-bin2"/>
                </button>
              </div>
              <button type="button" id="close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div v-if="indeks !== undefined && fileExtension !== ''">
                <div v-if="this.fileExtension === 'pdf'">
                  <embed style="height: 800px" type="application/pdf"
                         :src="globalPdfUrl"
                         width="100%" height="100%" alt="pdf"
                         background-color="0xFF525659" top-toolbar-height="56" full-frame=""
                         internalinstanceid="21"
                         title="CHROME">
                </div>
                <div v-else>
                  <img :src="globalImgUrl"
                       style="width: -webkit-fill-available; height: 400px; object-fit: contain;">
                </div>
              </div>
              <div v-else class='shadow p-3 mb-5 bg-body rounded' style='border: 1px solid red'>
                <p class='p-3 text-center' style='color: #b7323e'>
                  No Documents</p>
              </div>
            </div>


          </div>
        </div>
      </div>
      <!--      Permisson Modal-->
      <div class="modal fade" id="permissionModal" tabindex="-1" aria-labelledby="permissionModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <div class="card-body text-start">
                <span class="card-title fw-bold" style="font-size: 1rem"> Permission Modal </span>
              </div>
              <button type="button" id="close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6 gx-2">
                  <div class="pt-2">
                    <div class="card col-12 mb-1">
                      <div class="row">
                        <div class="col-10">
                          <div class="m-2 col-lg-3 col-md-6 col-sm-12">
                            <div class="input-group pe-3">
                              <input class="form-control" required maxlength="50" placeholder="Search"
                                     v-model="userSearch">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <div class="card table-responsive tableFixHead" style="max-height: 750px">
                      <table class="table table-striped align-middle"
                             style="overflow-x: auto; overflow-y: auto">
                        <thead>
                        <tr>
                          <th style="background-color: rgb(86, 117, 156); color: white">
                            Full Name
                          </th>
                          <th style="background-color: rgb(86, 117, 156); color: white">
                            Email
                          </th>
                          <th style="background-color: rgb(86, 117, 156); color: white">
                            Perms
                          </th>
                        </tr>
                        </thead>
                        <tbody>

                        <template v-for="(user, index) in permsUserFilteredData">
                          <tr style="cursor: pointer" id="permission" @click="toggle(user)" :key="index+'-'+user.ID"
                              :class="{ opened: opened.includes(user.ID)}">
                            <td>{{ user.FULLNAME }}</td>
                            <td>{{ user.EMAIL }}</td>
                            <td v-if="user.PERMS" class="text-success">Permissions</td>
                            <td v-else class="text-danger">No Permission</td>
                          </tr>
                          <template v-for="(perms, index) in user.PERMS">
                            <tr :key="perms.ID + '_' +index" v-if="opened.includes(user.ID)">
                              <td colspan="2"> Perm {{ ++index }}: {{ perms.PERM_NAME }}</td>
                              <td>
                                <button type="button" class="btn btn-outline-danger btn-sm"
                                        @click="deletePermSelectedUser(permissionID, perms.PERM_NAME)"><i
                                    class="icon-bin2"/></button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>


                <div class="col-sm-12 col-md-6 col-lg-6">
                  <div class="pt-2">
                    <div class="card col-12 mb-1">
                      <div class="row">
                        <div class="col-10">
                          <div class="m-2 col-lg-3 col-md-6 col-sm-12">
                            <div class="input-group pe-3">
                              <input class="form-control" required maxlength="50" placeholder="Search"
                                     v-model="DistSearch">
                            </div>
                          </div>
                        </div>
                        <div class="col-12" v-if="permissionID != -1">
                          <div class="alert alert-warning d-flex align-items-center justify-content-center"
                               role="alert">
                            <div>
                              You are adding user permission {{ permFullName }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <div class="card table-responsive tableFixHead" style="max-height: 750px">
                      <table class="table table-striped align-middle "
                             style="overflow-x: auto; overflow-y: auto">
                        <thead>
                        <tr>
                          <th style="background-color: rgb(86, 117, 156); color: white">Company Code</th>
                          <th style="background-color: rgb(86, 117, 156); color: white">Position Code</th>
                          <th style="background-color: rgb(86, 117, 156); color: white">Position Name</th>
                          <th style="background-color: rgb(86, 117, 156); color: white">Shortcode</th>
                          <th style="background-color: rgb(86, 117, 156); color: white">Work Area</th>
                          <th style="background-color: rgb(86, 117, 156); color: white"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(dist,index) in permsDistinctedFilteredData" :key="index">
                          <td>{{ dist.CompanyCode }}</td>
                          <td>{{ dist.PositionCode }}</td>
                          <td>{{ dist.PositionName }}</td>
                          <td>{{ dist.SHORTCODE }}</td>
                          <td>{{ dist.WorkArea }}</td>
                          <td>
                            <button type="button" class="btn btn-outline-success btn-sm"
                                    @click="addPermSelectedUser(permissionID, dist.SHORTCODE,dist)"><i class="icon-plus"/>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      <!--      /Permisson Modal-->
    </div>
    <div class="col-1"></div>
  </div>
</template>

<style scoped>

.status {
  width: 15px;
  height: 15px;
}

.nav-pills .nav-link.active {
  background-color: rgb(86, 117, 156);
}

.csp {
  background-color: #40E0D0!important;
}

.form-check-input:checked {
  background-color: rgb(86, 117, 156);
  color: #fff;
}

input {
  font-size: 14px;
}

.table {
  --bs-table-striped-bg: rgb(86, 117, 156, 0.1);
  margin-bottom: 0
}

.row {
  --bs-gutter-x: 0 !important;
}

.btn-outline-default {
  --bs-btn-color: rgb(86, 117, 156);
  --bs-btn-border-color: rgb(86, 117, 156);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(86, 117, 156);
  --bs-btn-hover-border-color: rgb(86, 117, 156);
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86, 117, 156);
  --bs-btn-active-border-color: rgb(86, 117, 156);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: rgb(86, 117, 156);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: rgb(86, 117, 156);
  --bs-gradient: none;
}

a {
  color: rgb(86, 117, 156);
}

.tableFixHead {
  overflow: auto;
}

.tableFixHead thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.tooltip {
  display: contents;
  color: black;
  position: relative;
  border-bottom: 1px dotted #666;
  text-align: left;
}

.tooltip .bottom {
  min-width: 250px;
  top: 50px;
  left: 98%;
  transform: translate(-49%, 0);
  padding: 10px 20px;
  color: #444444;
  background-color: #eef1f5;
  font-weight: normal;
  font-size: 13px;
  border-radius: 8px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  display: none;
}

.tooltip:hover .bottom {
  display: block;
}

.tooltip .bottom i {
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 12px;
  overflow: hidden;
}

.tooltip .bottom i::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  left: 50%;
  transform: translate(-50%, 50%) rotate(45deg);
  background-color: #EEEEEE;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

h5 {
  font-size: 0.9rem;
  font-weight: bold;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType
  from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import HRPersonelRequestService from "@/services/HRPersonelRequest.service";
import {mapActions} from "vuex";
import {API} from "@/utils/mixins.js"
import Vue from "vue";
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

Vue.use(require('vue-moment'));
import moment from 'moment'
import {createUrl} from "@/http";
// import CustomInput from "@/components/CustomInput";

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
export default {
  mixins: [API],
  components: {
    FilePond,
    Multiselect,
    DatePicker,
    // CustomInput
  },
  data() {
    return {
      selectedValue : "Select",
      isActiveSubTable: false,
      opened: [],
      selectedIndex: -1,
      visible: false,
      globalImgUrl: "",
      globalPdfUrl: "",
      tabIndex: 0,
      btnCreateLabel: "",
      multiSelectValue: [],
      multiSelectOptions: [],
      nationalityOptions: [],
      nationalityOptionsValue: "",
      personelList: [],
      imageUrl: "",
      personelListByID: [],
      isDeleted: false,
      isShow: false,
      isCreated: true,
      isCreatedBtn: false,
      search: "",
      searchTLC: "",
      userSearch: "",
      DistSearch: "",
      user: [],
      headers: ['Name', 'Surname', "Gender", 'TLC', 'Email', 'Rank'],
      file: "",
      file2: "",
      file3: "",
      file4: "",
      isActiveClass: "",
      getImageUrl: createUrl("HR/personel/ShowImageVer2"),
      getPdfUrl: createUrl("HR/personel/ShowPdfVer2"),
      fileExtension: "",
      personInformation: [],
      medicalCheckInformation: [],
      licenceInformation: [],
      visaInformation: [],
      passportInformation: [],
      landingInformation: [],
      indeksNo: [],
      selectedIndexFileExtension: [],
      DocPID: "",
      indeks: "",
      tooltipVisible: false,
      usersWithPerms: [],
      distinctedPositions: [],
      permissionID: -1,
      permFullName: "",
      userPermsList: [],
      permissionShortCode: "",
      isToggleActived: [],
      iconList: [
        {
          type: true,
          icon: "icon-plus"
        },
        {
          type: false,
          icon: "icon-minus"
        }
      ],


      genders: [
        {
          gender: "Male",
          value: "M"
        },
        {
          gender: "Female",
          value: "F",
        }
      ],

      documentForm: {
        id: "",
        documentTypeID: "",
        documentTypeIndex: "",
        Document_P_ID: "",
        documentIndeksNo: ""
      },
      personCheckInputForm: {
        Id: "",
        file: {},
        file2: {},
        file3: {},
        file4: {},
        name: "",
        surname: "",
        tlc: "",
        description: "",
        mail: "",
        birtdate: "",
        gender: "",
        documentType: "",
        identity: "",
        baseCountry: "",
        rank: -1,
        Nefa_Employee_Id: "",
        CompanyCode: "",
        company: "",
      },
      medicalCheckInputForm: {
        id: "",
        dateOfIssue: "",
        dateOfExpiry: "",
        type: "",
        multiselectType: "",
        CVL_DESCRIPTION: "",
        LICENCE_TYPE: "",
        LICENCE_NO: "",
        stat: -1,
        subStat: -1,
        whoUpload: "",
      },
      passportInputForm: {
        id: "",
        documentPID: "",
        name: "",
        surname: "",
        passportNR: "",
        dateOfIssue: "",
        dateOfExpiry: "",
        countryOfIssue: "",
        placeOfIssue: "",
        stat: -1,
        whoUpload: "",
      },
      visaInputForm: {
        id: "",
        passportNR: "",
        country: "",
        dateOfIssue: "",
        dateOfExpiry: "",
        placeOfIssue: "",
        visaNR: "",
        stat: -1,
        subStat: -1,
        whoUpload: "",
      },
      licenseInformationInputForm: {
        id: "",
        licenseType: "",
        licenseNumber: "",
        authority: "",
        issueCountry: "",
        licenseExpiry: "",
        examinerLicenseNR: "",
        examinerLicenseEmpiry: "",
        RATING_CERTIFICATE: "",
        LICENCE_TITLE: "",
        LANGUAGE_1: "",
        LANGUAGE_1_LEVEL: "",
        LANGUAGE_1_DATE: "",
        LANGUAGE_2: "",
        LANGUAGE_2_LEVEL: "",
        LANGUAGE_2_DAT: "",
        stat: -1,
        whoUpload: "",

      },
      landingInformationInputForm: {
        expriyDate: "",
        stat: -1,
        whoUpload: "",

      },

      statColorList: [
        {
          value: -1,
          color: "white",
        },
        {
          value: 1,
          color: "#8cc3a9",
        },
        {
          value: 2,
          color: "#ffe083",
        },
        {
          value: 3,
          color: "#ed9aa2",
        },
        {
          value: 4,
          color: "#909294",
        }
      ],

      fileUploadLocalServer: {
        process: (fieldName, file, metadata, load) => {
          (async () => {
            try {
              this.personCheckInputForm.file = file;
              load();
            } catch (e) {
              this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"});
            }
          })();
        },
      },
      fileUploadLocalServer2: {
        process: (fieldName, file, metadata, load) => {
          (async () => {
            try {
              this.personCheckInputForm.file2 = file;
              load();
            } catch (e) {
              this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"});
            }
          })();
        },
      },
      fileUploadLocalServer3: {
        process: (fieldName, file, metadata, load) => {
          (async () => {
            try {
              this.personCheckInputForm.file3 = file;
              load();
            } catch (e) {
              this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"});
            }
          })();
        },
      },
      fileUploadLocalServer4: {
        process: (fieldName, file, metadata, load) => {
          (async () => {
            try {
              this.personCheckInputForm.file4 = file;
              load();
            } catch (e) {
              this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"});
            }
          })();
        },
      }
    }
  },

  methods: {
    ...mapActions["DeleteHRPersonel", "UpdateHRPersonel", "AddHRPersonel", "getAllAndGetByMail", "DeleteDocument", "UploadVisaInformation", "UploadMedicalCheckInformation", "UploadPassaport", "UploadLicenceInformation", "getCvlTypes", "getUsersWithPerms", "getDistinctedPositions"],
    async getAllDataByMail(userId) {
      try {
        let res = await this.$store.dispatch("HRPersonelRequest/getAllAndGetByMail", userId);
        this.personelList = JSON.parse(this.API_ResultContainerControl(res));
        res = "";
      } catch (e) {
        this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"})
      }
    },

    TR2EN(list) {
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(list).replaceAll('İ', 'I').replaceAll('Ö', 'O').replaceAll('Ü', 'U')
          .replaceAll('Ş', 'S').replaceAll('Ç', 'C').replaceAll('Ğ', 'G'))
      return newArr;
    },

    toggle(user) {
      try {
        this.permissionID = user.ID;
        this.permFullName = user.FULLNAME;
        this.userPermsList = user.PERMS;
        const idx = this.opened.indexOf(user.ID);
        if (idx > -1) {
          //document.getElementById("permission").style.background ="white";
          this.opened.splice(idx, 1)
        } else {
          //document.getElementById("permission").style.background ="green";
          this.opened.push(user.ID)
        }
      } catch (e) {
        this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"})
      }
    },


    icon(opened) {
      if (!opened) {
        return this.iconList.find(x => x.type === true).icon
      } else {
        return this.iconList.find(x => x.type === false).icon
      }
    },

    statusColor(colorIndex) {
      if (colorIndex !== undefined) {
        return this.statColorList.find(x => x.value === colorIndex).color
      } else {
        return
      }
    },
    getReport(){
      //console.log("test: " + this.selectedValue);
      //this.getAllDataByMail(this.user)
      
      console.log(this.filteredData)
    },
    showImgBtn(idx) {
      this.indeks = "";
      this.selectedIndex = idx + 1;
      if (this.indeksNo !== null) {
        this.indeks = this.indeksNo[idx]
        this.fileExtension = this.selectedIndexFileExtension.find(x => x.indeksNo == this.selectedIndex).fileExtension;
      }
      this.getFullImgUrl();
      this.getFullPdfUrl();
    },

    arrayDesigner(array) {
      let newArray = {};
      if (Object.keys(array).length > 0) {
        for (var k = 0; k < array.length; k++) {
          if (array[k] !== undefined) {
            if (array[k].DOCUMENT_P_ID in newArray) {
              newArray[array[k].DOCUMENT_P_ID][array[k].DOCUMENT_INDEKS_NO] = array[k];
            } else {
              newArray[array[k].DOCUMENT_P_ID] = {};
              newArray[array[k].DOCUMENT_P_ID][array[k].DOCUMENT_INDEKS_NO] = {};
              newArray[array[k].DOCUMENT_P_ID][array[k].DOCUMENT_INDEKS_NO] = array[k];
            }
          }
        }

      }
      return newArray;
    },

    async getDataById(data) {
      this.isCreatedBtn = false;
      await this.inputAllDataClean();
      try {
        let res = await this.$store.dispatch("HRPersonelRequest/getPersonByID", data.Id)
        this.personelListByID = await JSON.parse(this.API_ResultContainerControl(res));
        this.inputAllDataClean();
        this.getPersonInputAndAllData();
        this.personCheckInputForm.Id = await data.Id;
        this.personCheckInputForm.rank = data.Rank;
        this.passportInputForm.stat = data.STATPP;
        this.visaInputForm.stat = data.STATVS;
        this.licenseInformationInputForm.stat = data.STATLC;
        this.medicalCheckInputForm.stat = data.STATMC;
        this.landingInformationInputForm.stat = data.STATLD;
        if (this.documentForm.documentTypeIndex === 1) {
          if (Object.keys(this.passportInformation).length !== 0) {
            await this.getPassportInputDataByIndex(0, this.passportInformation[Object.keys(this.passportInformation)[0]])
          }
        }
        if (this.documentForm.documentTypeIndex === 2) {
          if (Object.keys(this.visaInformation).length !== 0) {
            await this.getVisaInputDataByIndex(0, this.visaInformation[Object.keys(this.visaInformation)[0]])
          }
        }
        if (this.documentForm.documentTypeIndex === 3) {
          if (Object.keys(this.licenceInformation).length !== 0) {
            await this.getLicenseInputDataByIndex(0, this.licenceInformation[Object.keys(this.licenceInformation)[0]])
          }
        }
        if (this.documentForm.documentTypeIndex === 4) {
          if (Object.keys(this.medicalCheckInformation).length !== 0) {
            await this.getMedicalCheckInputDataByIndex(0, this.medicalCheckInformation[Object.keys(this.medicalCheckInformation)[0]])
          }
        }
        if (this.documentForm.documentTypeIndex === 5) {
          if (Object.keys(this.landingInformation).length !== 0) {
            await this.getLandingInputDataByIndex(0, this.landingInformation[Object.keys(this.landingInformation)[0]])
          }
        }
        if (res.severity === 1) {
          this.isCreated = false;
          this.isDeleted = true;
          this.isShow = true;
          // res = "";
        }
        if (res.severity === 2) {
          this.$notify({title: "Error", type: "error", text: res.data.lastError})
        }
        if (res.severity === 3) {
          this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
        }
      } catch (e) {
        this.$notify({title: 'Error', text: "getDataById " + e.message, type: "error", duration: "15000"});
      }
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },


    async getCVLTypes() {
      try {
        let res = await this.$store.dispatch("HRPersonelRequest/getCvlTypes");
        this.multiSelectOptions = JSON.parse(this.API_ResultContainerControl(res));

        if (res.severity === 1) {
          this.$notify({title: 'Success', type: "success", duration: "15000"});
        }
        if (res.severity === 2) {
          this.$notify({title: "Error", type: "error", text: res.data.lastError})
        }
        if (res.severity === 3) {
          this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
        }
      } catch (e) {
        this.$notify({title: 'Error', text: "getCVLTypes " + e.message, type: "error", duration: "15000"});
      }
    },

    async getCountries() {
      try {
          let res = await this.$store.dispatch("HRPersonelRequest/getCountries");
          this.nationalityOptions = JSON.parse(this.API_ResultContainerControl(res));

        if (res.severity === 1) {
          this.$notify({title: 'Success', type: "success", duration: "15000"});
        }
        if (res.severity === 2) {
          this.$notify({title: "Error", type: "error", text: res.data.lastError})
        }
        if (res.severity === 3) {
          this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
        }
      } catch (e) {
        this.$notify({title: 'Error', text: "getCountries " + e.message, type: "error", duration: "15000"});
      }
    },

    nameWithLang ({ CountryDesc, CountryCode }) {
      return `${CountryDesc} — [${CountryCode}]`
    },

    async getUsersWithPerms() {
      try {
        let res = await this.$store.dispatch("HRPersonelRequest/getUsersWithPerms");
        this.usersWithPerms = await JSON.parse(this.API_ResultContainerControl(res));
        if (res.severity === 1) {
          return
        }
        if (res.severity === 2) {
          this.$notify({title: "Error", type: "error", text: res.data.lastError})
        }
        if (res.severity === 3) {
          this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
        }
      } catch (e) {
        this.$notify({title: 'Error', text: "getUsersWithPerms " + e.message, type: "error", duration: "15000"});
      }
    },

    async getDistinctedPositions() {
      try {
        let res = await this.$store.dispatch("HRPersonelRequest/getDistinctedPositions");
        this.distinctedPositions = JSON.parse(this.API_ResultContainerControl(res));
        if (res.severity === 1) {
          return
        }
        if (res.severity === 2) {
          this.$notify({title: "Error", type: "error", text: res.data.lastError})
        }
        if (res.severity === 3) {
          this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
        }
      } catch (e) {
        this.$notify({title: 'Error', text: "getDistinctedPositions " + e.message, type: "error", duration: "15000"});

      }
    },

    async addPermSelectedUser(id, code) {
      await this.$swal({
        title: '<p style="text-align: center;font-size: 22px;">Do you want to add user permission?</p>',
        html: "",
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#e55050',
        confirmButtonColor: '#186c81cc',
        confirmButtonText: 'Yes',
      }).then(async (response) => {
        if (response.value) {
          {
            if (this.userPermsList == undefined || this.userPermsList.find(x => x.PERM_NAME === code) == undefined) {
              try {
                let res = await this.$store.dispatch("HRPersonelRequest/addPermSelectedUser", {
                  UserId: id,
                  ShortCode: code,
                });
                this.API_ResultContainerControl(res);
                await this.getUsersWithPerms();
                this.toggle(this.usersWithPerms[--this.permissionID])
                // this.permissionID = this.usersWithPerms[--this.permissionID].ID;
                // this.permFullName = this.usersWithPerms[--this.permissionID].FULLNAME;
                // this.userPermsList = this.usersWithPerms[--this.permissionID].PERMS;
                if (res.severity === 1) {
                  this.$notify({title: 'Success', type: "success", duration: "15000"});
                }
                if (res.severity === 2) {
                  this.$notify({title: "Error", type: "error", text: res.data.lastError})
                }
                if (res.severity === 3) {
                  this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
                }
              } catch (e) {
                this.$notify({
                  title: 'Error',
                  text: "addPermSelectedUser " + e.message,
                  type: "error",
                  duration: "15000"
                });
              }
            }
            else {
              this.$notify({title: "Warning", type: "warning", text: "The relevant permission was added previously."})
            }
          }
        }
      });

    },

    async deletePermSelectedUser(id, code) {
      await this.$swal({
        title: '<p style="text-align: center;font-size: 22px;">Do you want to delete user permission?</p>',
        html: "",
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#e55050',
        confirmButtonColor: '#186c81cc',
        confirmButtonText: 'Yes',
      }).then(async (response) => {
        if (response.value) {
          try {
            let res = await this.$store.dispatch("HRPersonelRequest/deletePermSelectedUser", {id, code})
            this.API_ResultContainerControl(res);
            await this.getUsersWithPerms();
            if (res.severity === 1) {
              this.$notify({title: 'Success', type: "success", duration: "15000"});
            }
            if (res.severity === 2) {
              this.$notify({title: "Error", type: "error", text: res.data.lastError})
            }
            if (res.severity === 3) {
              this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
            }
          } catch (e) {
            this.$notify({
              title: 'Error',
              text: "deletePermSelectedUser " + e.message,
              type: "error",
              duration: "15000"
            });
          }
        }
      });

    },

    async getPersonInputAndAllData() {
      let personalData = await this.personelListByID;
      this.medicalCheckInformation = this.arrayDesigner(personalData.List_MedicalCheckInformation);
      this.visaInformation = this.arrayDesigner(personalData.List_VisaInformaiton);
      this.passportInformation = this.arrayDesigner(personalData.List_PassaportInfo);
      this.licenceInformation = this.arrayDesigner(personalData.List_LicenceInformation);
      this.landingInformation = this.arrayDesigner(personalData.List_LandingInformation);
      this.personInformation = this.arrayDesigner(personalData.person);

      this.personInformation = await this.personelListByID.person;
      // this.landingInformation = await this.personelListByID.List_LandingInformation;

      this.personCheckInputForm.name = this.personInformation[0].NAME;
      this.personCheckInputForm.surname = this.personInformation[0].SURNAME;
      this.personCheckInputForm.tlc = this.personInformation[0].TLC;
      this.personCheckInputForm.mail = this.personInformation[0].EMAIL
      this.personCheckInputForm.birtdate = moment(this.personelListByID.person[0].BIRTHDATE).format('YYYY-MM-DD');
      this.personCheckInputForm.gender = this.personInformation[0].GENDER;
      this.personCheckInputForm.identity = this.personInformation[0].IDENTITYDEF;
      this.personCheckInputForm.Nefa_Employee_Id = this.personInformation[0].IDENTITYDEF;
      this.personCheckInputForm.CompanyCode = this.personInformation[0].COMPANY;
    },

    async getPassportInputDataByIndex(idx, form) {
      this.inputTabDataClean();
      this.documentForm.documentTypeIndex = 1;
      this.indeksNo = [];
      this.DocPID = "";
      this.DocPID = form[Object.keys(form)[0]].DOCUMENT_P_ID
      this.selectedIndexFileExtension = [];
      for (var i = 0; i < Object.keys(form).length; i++) {
        this.indeksNo[i] = form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO;
        this.selectedIndexFileExtension.push({
          indeksNo: form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO,
          fileExtension: form[Object.keys(form)[i]].DOCUMENT_EXTENSION
        })

        // this.selectedIndexFileExtension[i].indeksNo = form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO;
        // this.selectedIndexFileExtension[i].fileExtension = form[Object.keys(form)[i]].DOCUMENT_EXTENSION;
      }
      // geçici olarak
      let tempFormLastUpt = this.findLatestUpdatedObject(Object.values(form))
      this.tabIndex = idx;
      this.fileExtension = tempFormLastUpt.DOCUMENT_EXTENSION;
      this.documentForm.documentTypeID = tempFormLastUpt.ID;
      this.documentForm.Document_P_ID = tempFormLastUpt.DOCUMENT_P_ID;
      this.documentForm.documentIndeksNo = tempFormLastUpt.DOCUMENT_INDEKS_NO;
      this.passportInputForm.id = tempFormLastUpt.ID;
      // this.passportInputForm.stat = tempFormLastUpt.STAT;
      this.passportInputForm.documentPID = tempFormLastUpt.DOCUMENT_P_ID;
      this.passportInputForm.passportNR = tempFormLastUpt.DOCUMENT_NUMBER;
      this.passportInputForm.dateOfIssue = moment(tempFormLastUpt.DATE_OF_ISSUE).format('YYYY-MM-DD');
      this.passportInputForm.countryOfIssue = tempFormLastUpt.COUNTRY_OF_ISSUE;
      this.passportInputForm.dateOfExpiry = moment(tempFormLastUpt.DATE_OF_EXPIRY).format('YYYY-MM-DD');
      this.passportInputForm.placeOfIssue = tempFormLastUpt.PLACE_OF_ISSUE;
      this.passportInputForm.whoUpload = tempFormLastUpt.DOCUMENT_WHO_UPLOAD;
      this.nationalityOptionsValue = (this.nationalityOptions.find(x => x.CountryCode == tempFormLastUpt.NATIONALITY_CODE));

    },

    async getVisaInputDataByIndex(idx, form) {
      this.inputTabDataClean();

      this.documentForm.documentTypeIndex = 2;
      this.indeksNo = [];
      this.DocPID = "";
      this.DocPID = form[Object.keys(form)[0]].DOCUMENT_P_ID
      this.selectedIndexFileExtension = [];
      for (var i = 0; i < Object.keys(form).length; i++) {
        this.indeksNo[i] = form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO;
        this.selectedIndexFileExtension.push({
          indeksNo: form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO,
          fileExtension: form[Object.keys(form)[i]].DOCUMENT_EXTENSION
        })

        // this.selectedIndexFileExtension[i].indeksNo = form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO;
        // this.selectedIndexFileExtension[i].fileExtension = form[Object.keys(form)[i]].DOCUMENT_EXTENSION;
      }
      // geçici olarak
      let tempFormLastUpt = this.findLatestUpdatedObject(Object.values(form))
      this.tabIndex = idx;
      this.fileExtension = tempFormLastUpt.DOCUMENT_EXTENSION;
      this.documentForm.documentTypeID = tempFormLastUpt.ID;
      this.documentForm.Document_P_ID = tempFormLastUpt.DOCUMENT_P_ID;
      this.documentForm.documentIndeksNo = tempFormLastUpt.DOCUMENT_INDEKS_NO;
      this.visaInputForm.id = tempFormLastUpt.ID;
      this.visaInputForm.subStat = tempFormLastUpt.STAT;
      this.visaInputForm.passportNR = tempFormLastUpt.DOCUMENT_NUMBER;
      this.visaInputForm.visaNR = tempFormLastUpt.VISA_NUMBER;
      this.visaInputForm.country = tempFormLastUpt.COUNTRY_OF_ISSUE
      this.visaInputForm.dateOfIssue = moment(tempFormLastUpt.DATE_OF_ISSUE).format('YYYY-MM-DD');
      this.visaInputForm.dateOfExpiry = moment(tempFormLastUpt.DATE_OF_EXPIRY).format('YYYY-MM-DD');
      this.visaInputForm.placeOfIssue = tempFormLastUpt.PLACE_OF_ISSUE;
      this.visaInputForm.whoUpload = tempFormLastUpt.DOCUMENT_WHO_UPLOAD;
    },


    findLatestUpdatedObject(list) {
      // Başlangıçta en son güncellenmiş nesneyi saklamak için boş bir nesne tanımlıyoruz
      // Başlangıçta en son güncellenmiş nesneyi saklamak için boş bir nesne tanımlıyoruz
      let latestUpdatedObject = {};
      // Tüm nesneleri döngü ile kontrol ediyoruz
      list.forEach((object) => {
        // Nesnenin updateddt değeri var mı kontrol ediyoruz
        if (Object.prototype.hasOwnProperty.call(object, 'UPDATE_DT')) {
          // En son güncellenen nesneyi bulmak için, şu anki en son nesne ile karşılaştırıyoruz
          if (!latestUpdatedObject.updateddt || object.updateddt > latestUpdatedObject.updateddt) {
            latestUpdatedObject = object;
          }
        }
      });


      // Son güncellenen nesneyi döndürüyoruz
      return latestUpdatedObject;
    },

    async getLicenseInputDataByIndex(idx, form) {
      this.inputTabDataClean();

      this.documentForm.documentTypeIndex = 3;
      this.indeksNo = [];
      this.DocPID = "";
      this.DocPID = form[Object.keys(form)[0]].DOCUMENT_P_ID
      this.selectedIndexFileExtension = [];
      for (var i = 0; i < Object.keys(form).length; i++) {
        this.indeksNo[i] = form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO;
        this.selectedIndexFileExtension.push({
          indeksNo: form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO,
          fileExtension: form[Object.keys(form)[i]].DOCUMENT_EXTENSION
        })

        // this.selectedIndexFileExtension[i].indeksNo = form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO;
        // this.selectedIndexFileExtension[i].fileExtension = form[Object.keys(form)[i]].DOCUMENT_EXTENSION;
      }
      // geçici olarak
      let tempFormLastUpt = this.findLatestUpdatedObject(Object.values(form))
      this.tabIndex = idx;

      this.fileExtension = tempFormLastUpt.DOCUMENT_EXTENSION;
      this.documentForm.documentTypeID = tempFormLastUpt.ID;
      this.documentForm.Document_P_ID = tempFormLastUpt.DOCUMENT_P_ID;
      this.documentForm.documentIndeksNo = tempFormLastUpt.DOCUMENT_INDEKS_NO;
      this.licenseInformationInputForm.id = tempFormLastUpt.ID;
      // this.licenseInformationInputForm.stat = tempFormLastUpt.STAT;
      this.licenseInformationInputForm.licenseNumber = tempFormLastUpt.LICENCE_NUMBER;
      this.licenseInformationInputForm.licenseType = tempFormLastUpt.LICENCE_TYPE;
      this.licenseInformationInputForm.authority = tempFormLastUpt.AUTHORITY;
      this.licenseInformationInputForm.issueCountry = tempFormLastUpt.ISSUE_COUNTRY;
      this.licenseInformationInputForm.licenseExpiry = moment(tempFormLastUpt.LICENCE_EXPIRY).format('YYYY-MM-DD');
      this.licenseInformationInputForm.examinerLicenseNR = tempFormLastUpt.EXAMINER_LICENCE_NR;
      this.licenseInformationInputForm.examinerLicenseEmpiry = moment(tempFormLastUpt.EXAMINER_LICENCE_EXPIRY).format('YYYY-MM-DD');
      this.licenseInformationInputForm.RATING_CERTIFICATE = tempFormLastUpt.RATING_CERTIFICATE;
      this.licenseInformationInputForm.LICENCE_TITLE = tempFormLastUpt.LICENCE_TITLE;
      this.licenseInformationInputForm.LANGUAGE_1 = tempFormLastUpt.LANGUAGE_1;
      this.licenseInformationInputForm.LANGUAGE_1_LEVEL = tempFormLastUpt.LANGUAGE_1_LEVEL;
      this.licenseInformationInputForm.LANGUAGE_1_DATE = moment(tempFormLastUpt.LANGUAGE_1_DATE).format('YYYY-MM-DD');
      this.licenseInformationInputForm.LANGUAGE_2 = tempFormLastUpt.LANGUAGE_2;
      this.licenseInformationInputForm.LANGUAGE_2_LEVEL = tempFormLastUpt.LANGUAGE_2_LEVEL;
      this.licenseInformationInputForm.LANGUAGE_2_DAT = moment(tempFormLastUpt.LANGUAGE_2_DATE).format('YYYY-MM-DD');
      this.licenseInformationInputForm.whoUpload = tempFormLastUpt.DOCUMENT_WHO_UPLOAD;
      // this.fileExtension = form[Object.keys(form)[0]].DOCUMENT_EXTENSION;
      // this.documentForm.documentTypeID = form[Object.keys(form)[0]].ID;
      // this.documentForm.Document_P_ID = form[Object.keys(form)[0]].DOCUMENT_P_ID;
      // this.documentForm.documentIndeksNo = form[Object.keys(form)[0]].DOCUMENT_INDEKS_NO;
      // this.licenseInformationInputForm.id = form[Object.keys(form)[0]].ID;
      // this.licenseInformationInputForm.licenseNumber = form[Object.keys(form)[0]].LICENCE_NUMBER;
      // this.licenseInformationInputForm.licenseType = form[Object.keys(form)[0]].LICENCE_TYPE;
      // this.licenseInformationInputForm.authority = form[Object.keys(form)[0]].AUTHORITY;
      // this.licenseInformationInputForm.issueCountry = form[Object.keys(form)[0]].ISSUE_COUNTRY;
      // this.licenseInformationInputForm.licenseExpiry = moment(form[Object.keys(form)[0]].LICENCE_EXPIRY).format('YYYY-MM-DD');
      // this.licenseInformationInputForm.examinerLicenseNR = form[Object.keys(form)[0]].EXAMINER_LICENCE_NR;
      // this.licenseInformationInputForm.examinerLicenseEmpiry = moment(form[Object.keys(form)[0]].EXAMINER_LICENCE_EXPIRY).format('YYYY-MM-DD');
    },

    async getMedicalCheckInputDataByIndex(idx, form) {
      this.inputTabDataClean();

      this.documentForm.documentTypeIndex = 4;
      this.indeksNo = [];
      this.DocPID = "";
      this.DocPID = form[Object.keys(form)[0]].DOCUMENT_P_ID
      this.selectedIndexFileExtension = [];
      for (var i = 0; i < Object.keys(form).length; i++) {
        this.indeksNo[i] = form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO;
        this.selectedIndexFileExtension.push({
          indeksNo: form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO,
          fileExtension: form[Object.keys(form)[i]].DOCUMENT_EXTENSION
        })

        // this.selectedIndexFileExtension[i].indeksNo = form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO;
        // this.selectedIndexFileExtension[i].fileExtension = form[Object.keys(form)[i]].DOCUMENT_EXTENSION;
      }
      let tempFormLastUpt = this.findLatestUpdatedObject(Object.values(form))
      // geçici olarak
      this.tabIndex = idx;
      this.fileExtension = tempFormLastUpt.DOCUMENT_EXTENSION;
      this.documentForm.documentTypeID = tempFormLastUpt.ID;
      this.documentForm.Document_P_ID = tempFormLastUpt.DOCUMENT_P_ID;
      this.documentForm.documentIndeksNo = tempFormLastUpt.DOCUMENT_INDEKS_NO;


      this.medicalCheckInputForm.type = tempFormLastUpt.MEDCTYPE;
      this.medicalCheckInputForm.id = tempFormLastUpt.ID;
      this.medicalCheckInputForm.subStat = tempFormLastUpt.STAT;
      this.medicalCheckInputForm.dateOfIssue = moment(tempFormLastUpt.DATE_OF_ISSUE).format('YYYY-MM-DD');
      this.medicalCheckInputForm.dateOfExpiry = moment(tempFormLastUpt.DATE_OF_EXPIRY).format('YYYY-MM-DD');
      this.medicalCheckInputForm.CVL_DESCRIPTION = tempFormLastUpt.CVL_DESCRIPTION;
      this.medicalCheckInputForm.LICENCE_NO = tempFormLastUpt.LICENCE_NO;
      this.medicalCheckInputForm.LICENCE_TYPE = tempFormLastUpt.LICENCE_TYPE;
      this.multiSelectValue = tempFormLastUpt.PILOT_CVL_TYPES.split(",");
      this.medicalCheckInputForm.whoUpload = tempFormLastUpt.DOCUMENT_WHO_UPLOAD;
    },

    async getLandingInputDataByIndex(idx, form) {
      this.DocPID = "";
      this.DocPID = form[Object.keys(form)[0]].DOCUMENT_P_ID
      this.selectedIndexFileExtension = [];
      for (var i = 0; i < Object.keys(form).length; i++) {
        this.indeksNo[i] = form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO;
        this.selectedIndexFileExtension.push({
          indeksNo: form[Object.keys(form)[i]].DOCUMENT_INDEKS_NO,
          fileExtension: form[Object.keys(form)[i]].DOCUMENT_EXTENSION
        })
      }
      let tempFormLastUpt = this.findLatestUpdatedObject(Object.values(form))
      this.tabIndex = idx;
      this.fileExtension = tempFormLastUpt.DOCUMENT_EXTENSION;
      this.documentForm.documentTypeID = tempFormLastUpt.ID;
      this.documentForm.Document_P_ID = tempFormLastUpt.DOCUMENT_P_ID;
      this.documentForm.documentIndeksNo = tempFormLastUpt.DOCUMENT_INDEKS_NO;
      this.documentForm.documentTypeIndex = 5;
      // this.landingInformationInputForm.stat = tempFormLastUpt.STAT;
      this.landingInformationInputForm.expriyDate = moment(tempFormLastUpt.EXPIRYDATE).format('YYYY-MM-DD');
      this.landingInformationInputForm.whoUpload = tempFormLastUpt.DOCUMENT_WHO_UPLOAD;
      this.isActiveSubTable = true;
    },

    inputAllDataClean() {
      this.isCreated = true;
      this.isShow = false;
      this.isDeleted = false;
      this.DocPID = "";
      this.indeks = "";
      this.documentForm.Document_P_ID = "";
      this.personCheckInputForm.file = "";
      this.personCheckInputForm.file2 = "";
      this.personCheckInputForm.file3 = "";
      this.personCheckInputForm.file4 = "";
      this.personCheckInputForm.name = "";
      this.personCheckInputForm.mail = "";
      this.personCheckInputForm.surname = "";
      this.personCheckInputForm.tlc = "";
      this.personCheckInputForm.description = "";
      this.personCheckInputForm.birtdate = "";
      this.personCheckInputForm.gender = "";
      this.personCheckInputForm.identity = "";
      this.personCheckInputForm.baseCountry = "";
      this.personCheckInputForm.rank = -1;
      this.documentForm.documentType = ""
      this.inputTabDataClean();
    },
    inputTabDataClean() {
      this.isCreatedBtn = false;
      this.tabIndex = null;
      if (this.personCheckInputForm.documentType !== 'General' && (this.file !== "" || this.file2 !== "" || this.file3 !== "" || this.file4 !== "")) {
        this.$refs.pond.removeFile();
        this.$refs.pond2.removeFile();
        this.$refs.pond3.removeFile();
        this.$refs.pond4.removeFile();
      }
      this.DocPID = "";
      this.indeks = "";
      this.documentForm.Document_P_ID = "";
      this.personCheckInputForm.file = "";
      this.personCheckInputForm.file2 = "";
      this.personCheckInputForm.file3 = "";
      this.personCheckInputForm.file4 = "";
      this.medicalCheckInputForm.multiselectType = "";
      this.medicalCheckInputForm.id = "";
      this.medicalCheckInputForm.type = "";
      this.medicalCheckInputForm.dateOfIssue = "";
      this.medicalCheckInputForm.dateOfExpiry = "";
      this.medicalCheckInputForm.LICENCE_TYPE = "";
      this.medicalCheckInputForm.LICENCE_NO = "";
      this.medicalCheckInputForm.CVL_DESCRIPTION = "";
      this.multiSelectValue = "";
      this.visaInputForm.id = "";
      this.visaInputForm.placeOfIssue = "";
      this.visaInputForm.dateOfExpiry = "";
      this.visaInputForm.country = "";
      this.visaInputForm.visaNR = "";
      this.visaInputForm.dateOfIssue = "";
      this.visaInputForm.passportNR = "";
      this.licenseInformationInputForm.id = "";
      this.licenseInformationInputForm.examinerLicenseEmpiry = "";
      this.licenseInformationInputForm.examinerLicenseNR = "";
      this.licenseInformationInputForm.licenseExpiry = "";
      this.licenseInformationInputForm.licenseType = "";
      this.licenseInformationInputForm.issueCountry = "";
      this.licenseInformationInputForm.authority = "";
      this.licenseInformationInputForm.licenseNumber = "";
      this.licenseInformationInputForm.RATING_CERTIFICATE = "";
      this.licenseInformationInputForm.LICENCE_TITLE = "";
      this.licenseInformationInputForm.LANGUAGE_1 = "";
      this.licenseInformationInputForm.LANGUAGE_1_LEVEL = "";
      this.licenseInformationInputForm.LANGUAGE_1_DATE = "";
      this.licenseInformationInputForm.LANGUAGE_2 = "";
      this.licenseInformationInputForm.LANGUAGE_2_LEVEL = "";
      this.licenseInformationInputForm.LANGUAGE_2_DAT = "";
      this.passportInputForm.documentPID = "";
      this.passportInputForm.id = "";
      this.passportInputForm.passportNR = "";
      this.passportInputForm.placeOfIssue = "";
      this.passportInputForm.dateOfExpiry = "";
      this.passportInputForm.countryOfIssue = "";
      this.passportInputForm.dateOfIssue = "";
      this.landingInformationInputForm.expriyDate = "";
      this.nationalityOptionsValue = "";
    },

    btnCreate() {
      this.inputTabDataClean();
      this.isCreatedBtn = true;
    },

    async changeDocumentTypeByID(name, index) {
      this.inputTabDataClean();
      this.personCheckInputForm.documentType = name;
      this.documentForm.documentTypeIndex = index;
      this.btnCreateLabel = name;
      if (this.documentForm.documentTypeIndex === 1) {
        if (Object.keys(this.passportInformation).length !== 0) {
          await this.getPassportInputDataByIndex(0, this.passportInformation[Object.keys(this.passportInformation)[0]])
        }
      }
      if (this.documentForm.documentTypeIndex === 2) {
        if (Object.keys(this.visaInformation).length !== 0) {
          await this.getVisaInputDataByIndex(0, this.visaInformation[Object.keys(this.visaInformation)[0]])
        }
      }
      if (this.documentForm.documentTypeIndex === 3) {
        if (Object.keys(this.licenceInformation).length !== 0) {
          await this.getLicenseInputDataByIndex(0, this.licenceInformation[Object.keys(this.licenceInformation)[0]])
        }
      }
      if (this.documentForm.documentTypeIndex === 4) {
        if (Object.keys(this.medicalCheckInformation).length !== 0) {
          await this.getMedicalCheckInputDataByIndex(0, this.medicalCheckInformation[Object.keys(this.medicalCheckInformation)[0]])
        }
      }
      if (this.documentForm.documentTypeIndex === 5) {
        if (Object.keys(this.landingInformation).length !== 0) {
          await this.getLandingInputDataByIndex(0, this.landingInformation[Object.keys(this.landingInformation)[0]])
        }
      }
      if (this.personCheckInputForm.documentType !== 'General') {
        this.$refs.pond.removeFile();
        this.$refs.pond2.removeFile();
        this.$refs.pond3.removeFile();
        this.$refs.pond4.removeFile();
      }


    },

    async tryUpdateHRPersonel() {
      if (this.documentForm.documentTypeIndex == 1) {
        try {
          let res;
          if (Object.keys(this.personCheckInputForm.file).length !== 0) {
            res = await HRPersonelRequestService.UploadPassaportService({
              DocumentId: this.passportInputForm.documentPID === '' ? -1 : this.passportInputForm.documentPID,
              files: this.personCheckInputForm.file,
              DocumentIndeksNo: 1,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              DocumentNumber: this.passportInputForm.passportNR,
              DateOfIssue: this.passportInputForm.dateOfIssue,
              CountryOfIssue: this.passportInputForm.countryOfIssue,
              PlaceOfIssue: this.passportInputForm.placeOfIssue,
              DateOfExpiry: this.passportInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              Nationality: this.nationalityOptionsValue.CountryCode,

            });
            this.passportInputForm.documentPID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file2).length !== 0) {
            res = await HRPersonelRequestService.UploadPassaportService({
              DocumentId: this.passportInputForm.documentPID === '' ? -1 : this.passportInputForm.documentPID,
              files: this.personCheckInputForm.file2,
              DocumentIndeksNo: 2,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              DocumentNumber: this.passportInputForm.passportNR,
              DateOfIssue: this.passportInputForm.dateOfIssue,
              CountryOfIssue: this.passportInputForm.countryOfIssue,
              PlaceOfIssue: this.passportInputForm.placeOfIssue,
              DateOfExpiry: this.passportInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              Nationality: this.nationalityOptionsValue.CountryCode,

            });
            this.passportInputForm.documentPID = res.data.jsondata;

          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file3).length !== 0) {
            res = await HRPersonelRequestService.UploadPassaportService({
              DocumentId: this.passportInputForm.documentPID === '' ? -1 : this.passportInputForm.documentPID,
              files: this.personCheckInputForm.file3,
              DocumentIndeksNo: 3,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              DocumentNumber: this.passportInputForm.passportNR,
              DateOfIssue: this.passportInputForm.dateOfIssue,
              CountryOfIssue: this.passportInputForm.countryOfIssue,
              PlaceOfIssue: this.passportInputForm.placeOfIssue,
              DateOfExpiry: this.passportInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              Nationality: this.nationalityOptionsValue.CountryCode,
            });
            this.passportInputForm.documentPID = res.data.jsondata;

          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file4).length !== 0) {
            res = await HRPersonelRequestService.UploadPassaportService({
              DocumentId: this.passportInputForm.documentPID === '' ? -1 : this.passportInputForm.documentPID,
              files: this.personCheckInputForm.file4,
              DocumentIndeksNo: 4,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              DocumentNumber: this.passportInputForm.passportNR,
              DateOfIssue: this.passportInputForm.dateOfIssue,
              CountryOfIssue: this.passportInputForm.countryOfIssue,
              PlaceOfIssue: this.passportInputForm.placeOfIssue,
              DateOfExpiry: this.passportInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              Nationality: this.nationalityOptionsValue.CountryCode,
            });
            this.passportInputForm.documentPID = res.data.jsondata;

          }
          if (Object.keys(this.personCheckInputForm.file4).length === 0 && Object.keys(this.personCheckInputForm.file3).length === 0 && Object.keys(this.personCheckInputForm.file2).length === 0 && Object.keys(this.personCheckInputForm.file).length === 0) {
            res = await HRPersonelRequestService.UploadPassaportService({
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              DocumentId: this.passportInputForm.documentPID === '' ? -1 : this.passportInputForm.documentPID,
              DocumentIndeksNo: 1,
              DocumentNumber: this.passportInputForm.passportNR,
              DateOfIssue: this.passportInputForm.dateOfIssue,
              CountryOfIssue: this.passportInputForm.countryOfIssue,
              PlaceOfIssue: this.passportInputForm.placeOfIssue,
              DateOfExpiry: this.passportInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              Nationality: this.nationalityOptionsValue.CountryCode,
            });
            this.passportInputForm.documentPID = res.data.jsondata;
          }
-          this.API_ResultContainerControl(res);
          await this.getDataById(this.personCheckInputForm)
          if (res.data.severity === 1) {
            this.$notify({title: "Success", type: "success", text: "Succesfully"})
            this.$refs.pond.removeFile();
            this.$refs.pond2.removeFile();
            this.$refs.pond3.removeFile();
            this.$refs.pond4.removeFile();
            await this.inputTabDataClean();
            await this.getDataById(this.personCheckInputForm)
            await this.getAllDataByMail(this.user);
          }
          if (res.data.severity === 2) {
            this.$notify({title: "Error", type: "error", text: res.data.lastError})
          }
          if (res.data.severity === 3) {
            this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
          }
          this.$forceUpdate();
        } catch (e) {
          this.$notify({title: "Error", text: "tryUpdateHRPersonel" + e.message, type: "error"});
        }
      }
      if (this.documentForm.documentTypeIndex == 2) {
        try {
          let res;
          if (Object.keys(this.personCheckInputForm.file).length !== 0) {
            res = await HRPersonelRequestService.UploadVisaInformationService({
              files: this.personCheckInputForm.file,
              DocumentIndeksNo: 1,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              VisaNumber: this.visaInputForm.visaNR,
              PassaportNumber: this.visaInputForm.passportNR,
              DateOfIssue: this.visaInputForm.dateOfIssue,
              CountryOfIssue: this.visaInputForm.country,
              PlaceOfIssue: this.visaInputForm.placeOfIssue,
              DateOfExpiry: this.visaInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file2).length !== 0) {
            res = await HRPersonelRequestService.UploadVisaInformationService({
              files: this.personCheckInputForm.file2,
              DocumentIndeksNo: 2,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              VisaNumber: this.visaInputForm.visaNR,
              PassaportNumber: this.visaInputForm.passportNR,
              DateOfIssue: this.visaInputForm.dateOfIssue,
              CountryOfIssue: this.visaInputForm.country,
              PlaceOfIssue: this.visaInputForm.placeOfIssue,
              DateOfExpiry: this.visaInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file3).length !== 0) {
            res = await HRPersonelRequestService.UploadVisaInformationService({
              files: this.personCheckInputForm.file3,
              DocumentIndeksNo: 3,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              VisaNumber: this.visaInputForm.visaNR,
              PassaportNumber: this.visaInputForm.passportNR,
              DateOfIssue: this.visaInputForm.dateOfIssue,
              CountryOfIssue: this.visaInputForm.country,
              PlaceOfIssue: this.visaInputForm.placeOfIssue,
              DateOfExpiry: this.visaInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file4).length !== 0) {
            res = await HRPersonelRequestService.UploadVisaInformationService({
              files: this.personCheckInputForm.file4,
              DocumentIndeksNo: 4,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              VisaNumber: this.visaInputForm.visaNR,
              PassaportNumber: this.visaInputForm.passportNR,
              DateOfIssue: this.visaInputForm.dateOfIssue,
              CountryOfIssue: this.visaInputForm.country,
              PlaceOfIssue: this.visaInputForm.placeOfIssue,
              DateOfExpiry: this.visaInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          if (Object.keys(this.personCheckInputForm.file4).length === 0 && Object.keys(this.personCheckInputForm.file3).length === 0 && Object.keys(this.personCheckInputForm.file2).length === 0 && Object.keys(this.personCheckInputForm.file).length === 0) {
            res = await HRPersonelRequestService.UploadVisaInformationService({
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              DocumentIndeksNo: 1,
              VisaNumber: this.visaInputForm.visaNR,
              PassaportNumber: this.visaInputForm.passportNR,
              DateOfIssue: this.visaInputForm.dateOfIssue,
              CountryOfIssue: this.visaInputForm.country,
              PlaceOfIssue: this.visaInputForm.placeOfIssue,
              DateOfExpiry: this.visaInputForm.dateOfExpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          this.API_ResultContainerControl(res);
          await this.getDataById(this.personCheckInputForm)
          if (res.data.severity === 1) {
            this.$notify({title: "Success", type: "success", text: "Succesfully Update"})
            this.$refs.pond.removeFile();
            this.$refs.pond2.removeFile();
            this.$refs.pond3.removeFile();
            this.$refs.pond4.removeFile();
            await this.inputTabDataClean();
            await this.getDataById(this.personCheckInputForm)
            await this.getAllDataByMail(this.user);

          }

          if (res.data.severity === 2) {
            this.$notify({title: "Error", type: "error", text: res.data.lastError})
          }
          if (res.data.severity === 3) {
            this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
          }
          this.$forceUpdate();
        } catch (e) {
          this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"});
        }
      }
      if (this.documentForm.documentTypeIndex == 3) {
        try {
          let res;
          if (Object.keys(this.personCheckInputForm.file).length !== 0) {
            res = await HRPersonelRequestService.UploadLicenceInformationService({
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              files: this.personCheckInputForm.file,
              DocumentIndeksNo: 1,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              LicenseType: this.licenseInformationInputForm.licenseType,
              LicenseNumber: this.licenseInformationInputForm.licenseNumber,
              Authority: this.licenseInformationInputForm.authority,
              Issue_Country: this.licenseInformationInputForm.issueCountry,
              License_Expiry: this.licenseInformationInputForm.licenseExpiry,
              ExaminerLicenseNR: this.licenseInformationInputForm.examinerLicenseNR,
              ExaminerLicenseExpiry: this.licenseInformationInputForm.examinerLicenseEmpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              RATING_CERTIFICATE: this.licenseInformationInputForm.RATING_CERTIFICATE,
              LICENCE_TITLE: this.licenseInformationInputForm.LICENCE_TITLE,
              LANGUAGE_1: this.licenseInformationInputForm.LANGUAGE_1,
              LANGUAGE_1_LEVEL: this.licenseInformationInputForm.LANGUAGE_1_LEVEL,
              LANGUAGE_1_DATE: this.licenseInformationInputForm.LANGUAGE_1_DATE,
              LANGUAGE_2: this.licenseInformationInputForm.LANGUAGE_2,
              LANGUAGE_2_LEVEL: this.licenseInformationInputForm.LANGUAGE_2_LEVEL,
              LANGUAGE_2_DATE: this.licenseInformationInputForm.LANGUAGE_2_DAT,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file2).length !== 0) {
            res = await HRPersonelRequestService.UploadLicenceInformationService({
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              files: this.personCheckInputForm.file2,
              DocumentIndeksNo: 2,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              LicenseType: this.licenseInformationInputForm.licenseType,
              LicenseNumber: this.licenseInformationInputForm.licenseNumber,
              Authority: this.licenseInformationInputForm.authority,
              Issue_Country: this.licenseInformationInputForm.issueCountry,
              License_Expiry: this.licenseInformationInputForm.licenseExpiry,
              ExaminerLicenseNR: this.licenseInformationInputForm.examinerLicenseNR,
              ExaminerLicenseExpiry: this.licenseInformationInputForm.examinerLicenseEmpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              RATING_CERTIFICATE: this.licenseInformationInputForm.RATING_CERTIFICATE,
              LICENCE_TITLE: this.licenseInformationInputForm.LICENCE_TITLE,
              LANGUAGE_1: this.licenseInformationInputForm.LANGUAGE_1,
              LANGUAGE_1_LEVEL: this.licenseInformationInputForm.LANGUAGE_1_LEVEL,
              LANGUAGE_1_DATE: this.licenseInformationInputForm.LANGUAGE_1_DATE,
              LANGUAGE_2: this.licenseInformationInputForm.LANGUAGE_2,
              LANGUAGE_2_LEVEL: this.licenseInformationInputForm.LANGUAGE_2_LEVEL,
              LANGUAGE_2_DATE: this.licenseInformationInputForm.LANGUAGE_2_DAT,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file3).length !== 0) {
            res = await HRPersonelRequestService.UploadLicenceInformationService({
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              files: this.personCheckInputForm.file3,
              DocumentIndeksNo: 3,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              LicenseType: this.licenseInformationInputForm.licenseType,
              LicenseNumber: this.licenseInformationInputForm.licenseNumber,
              Authority: this.licenseInformationInputForm.authority,
              Issue_Country: this.licenseInformationInputForm.issueCountry,
              License_Expiry: this.licenseInformationInputForm.licenseExpiry,
              ExaminerLicenseNR: this.licenseInformationInputForm.examinerLicenseNR,
              ExaminerLicenseExpiry: this.licenseInformationInputForm.examinerLicenseEmpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              RATING_CERTIFICATE: this.licenseInformationInputForm.RATING_CERTIFICATE,
              LICENCE_TITLE: this.licenseInformationInputForm.LICENCE_TITLE,
              LANGUAGE_1: this.licenseInformationInputForm.LANGUAGE_1,
              LANGUAGE_1_LEVEL: this.licenseInformationInputForm.LANGUAGE_1_LEVEL,
              LANGUAGE_1_DATE: this.licenseInformationInputForm.LANGUAGE_1_DATE,
              LANGUAGE_2: this.licenseInformationInputForm.LANGUAGE_2,
              LANGUAGE_2_LEVEL: this.licenseInformationInputForm.LANGUAGE_2_LEVEL,
              LANGUAGE_2_DATE: this.licenseInformationInputForm.LANGUAGE_2_DAT,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file4).length !== 0) {
            res = await HRPersonelRequestService.UploadLicenceInformationService({
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              files: this.personCheckInputForm.file4,
              DocumentIndeksNo: 4,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              LicenseType: this.licenseInformationInputForm.licenseType,
              LicenseNumber: this.licenseInformationInputForm.licenseNumber,
              Authority: this.licenseInformationInputForm.authority,
              Issue_Country: this.licenseInformationInputForm.issueCountry,
              License_Expiry: this.licenseInformationInputForm.licenseExpiry,
              ExaminerLicenseNR: this.licenseInformationInputForm.examinerLicenseNR,
              ExaminerLicenseExpiry: this.licenseInformationInputForm.examinerLicenseEmpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              RATING_CERTIFICATE: this.licenseInformationInputForm.RATING_CERTIFICATE,
              LICENCE_TITLE: this.licenseInformationInputForm.LICENCE_TITLE,
              LANGUAGE_1: this.licenseInformationInputForm.LANGUAGE_1,
              LANGUAGE_1_LEVEL: this.licenseInformationInputForm.LANGUAGE_1_LEVEL,
              LANGUAGE_1_DATE: this.licenseInformationInputForm.LANGUAGE_1_DATE,
              LANGUAGE_2: this.licenseInformationInputForm.LANGUAGE_2,
              LANGUAGE_2_LEVEL: this.licenseInformationInputForm.LANGUAGE_2_LEVEL,
              LANGUAGE_2_DATE: this.licenseInformationInputForm.LANGUAGE_2_DAT,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          if (Object.keys(this.personCheckInputForm.file4).length === 0 && Object.keys(this.personCheckInputForm.file3).length === 0 && Object.keys(this.personCheckInputForm.file2).length === 0 && Object.keys(this.personCheckInputForm.file).length === 0) {
            res = await HRPersonelRequestService.UploadLicenceInformationService({
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              DocumentIndeksNo: 1,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              LicenseType: this.licenseInformationInputForm.licenseType,
              LicenseNumber: this.licenseInformationInputForm.licenseNumber,
              Authority: this.licenseInformationInputForm.authority,
              Issue_Country: this.licenseInformationInputForm.issueCountry,
              License_Expiry: this.licenseInformationInputForm.licenseExpiry,
              ExaminerLicenseNR: this.licenseInformationInputForm.examinerLicenseNR,
              ExaminerLicenseExpiry: this.licenseInformationInputForm.examinerLicenseEmpiry,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              RATING_CERTIFICATE: this.licenseInformationInputForm.RATING_CERTIFICATE,
              LICENCE_TITLE: this.licenseInformationInputForm.LICENCE_TITLE,
              LANGUAGE_1: this.licenseInformationInputForm.LANGUAGE_1,
              LANGUAGE_1_LEVEL: this.licenseInformationInputForm.LANGUAGE_1_LEVEL,
              LANGUAGE_1_DATE: this.licenseInformationInputForm.LANGUAGE_1_DATE,
              LANGUAGE_2: this.licenseInformationInputForm.LANGUAGE_2,
              LANGUAGE_2_LEVEL: this.licenseInformationInputForm.LANGUAGE_2_LEVEL,
              LANGUAGE_2_DATE: this.licenseInformationInputForm.LANGUAGE_2_DAT,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          this.API_ResultContainerControl(res);
          await this.getDataById(this.personCheckInputForm)

          if (res.data.severity === 1) {
            this.$notify({title: "Success", type: "success", text: "Succesfully Update"})
            this.$refs.pond.removeFile();
            this.$refs.pond2.removeFile();
            this.$refs.pond3.removeFile();
            this.$refs.pond4.removeFile();
            await this.inputTabDataClean();
            await this.getDataById(this.personCheckInputForm)
            await this.getAllDataByMail(this.user);

          }
          if (res.data.severity === 2) {
            this.$notify({title: "Error", type: "error", text: res.data.lastError})
          }
          if (res.data.severity === 3) {
            this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
          }
          this.$forceUpdate();
        } catch (e) {
          this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"});
        }
      }
      if (this.documentForm.documentTypeIndex == 4) {
        try {
          let res;
          if (Object.keys(this.personCheckInputForm.file).length !== 0) {
            res = await HRPersonelRequestService.UploadMedicalCheckInformationService({
              files: this.personCheckInputForm.file,
              DocumentIndeksNo: 1,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              MEDCTYPE: this.medicalCheckInputForm.type,
              DATE_OF_ISSUE: this.medicalCheckInputForm.dateOfIssue,
              DATE_OF_EXPIRY: this.medicalCheckInputForm.dateOfExpiry,
              CVLTypes: this.medicalCheckInputForm.multiselectType,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              CVL_DESCRIPTION: this.medicalCheckInputForm.CVL_DESCRIPTION,
              LICENCE_TYPE: this.medicalCheckInputForm.LICENCE_TYPE,
              LICENCE_NO: this.medicalCheckInputForm.LICENCE_NO,

            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file2).length !== 0) {
            res = await HRPersonelRequestService.UploadMedicalCheckInformationService({
              files: this.personCheckInputForm.file2,
              DocumentIndeksNo: 2,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              MEDCTYPE: this.medicalCheckInputForm.type,
              DATE_OF_ISSUE: this.medicalCheckInputForm.dateOfIssue,
              DATE_OF_EXPIRY: this.medicalCheckInputForm.dateOfExpiry,
              CVLTypes: this.medicalCheckInputForm.multiselectType,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              CVL_DESCRIPTION: this.medicalCheckInputForm.CVL_DESCRIPTION,
              LICENCE_TYPE: this.medicalCheckInputForm.LICENCE_TYPE,
              LICENCE_NO: this.medicalCheckInputForm.LICENCE_NO,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file3).length !== 0) {
            res = await HRPersonelRequestService.UploadMedicalCheckInformationService({
              files: this.personCheckInputForm.file3,
              DocumentIndeksNo: 3,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              MEDCTYPE: this.medicalCheckInputForm.type,
              DATE_OF_ISSUE: this.medicalCheckInputForm.dateOfIssue,
              DATE_OF_EXPIRY: this.medicalCheckInputForm.dateOfExpiry,
              CVLTypes: this.medicalCheckInputForm.multiselectType,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              CVL_DESCRIPTION: this.medicalCheckInputForm.CVL_DESCRIPTION,
              LICENCE_TYPE: this.medicalCheckInputForm.LICENCE_TYPE,
              LICENCE_NO: this.medicalCheckInputForm.LICENCE_NO,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file4).length !== 0) {
            res = await HRPersonelRequestService.UploadMedicalCheckInformationService({
              files: this.personCheckInputForm.file4,
              DocumentIndeksNo: 4,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              MEDCTYPE: this.medicalCheckInputForm.type,
              DATE_OF_ISSUE: this.medicalCheckInputForm.dateOfIssue,
              DATE_OF_EXPIRY: this.medicalCheckInputForm.dateOfExpiry,
              CVLTypes: this.medicalCheckInputForm.multiselectType,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              CVL_DESCRIPTION: this.medicalCheckInputForm.CVL_DESCRIPTION,
              LICENCE_TYPE: this.medicalCheckInputForm.LICENCE_TYPE,
              LICENCE_NO: this.medicalCheckInputForm.LICENCE_NO,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          if (Object.keys(this.personCheckInputForm.file4).length === 0 && Object.keys(this.personCheckInputForm.file3).length === 0 && Object.keys(this.personCheckInputForm.file2).length === 0 && Object.keys(this.personCheckInputForm.file).length === 0) {
            res = await HRPersonelRequestService.UploadMedicalCheckInformationService({
              DocumentIndeksNo: 1,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              MEDCTYPE: this.medicalCheckInputForm.type,
              DATE_OF_ISSUE: this.medicalCheckInputForm.dateOfIssue,
              DATE_OF_EXPIRY: this.medicalCheckInputForm.dateOfExpiry,
              CVLTypes: this.medicalCheckInputForm.multiselectType,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              CVL_DESCRIPTION: this.medicalCheckInputForm.CVL_DESCRIPTION,
              LICENCE_TYPE: this.medicalCheckInputForm.LICENCE_TYPE,
              LICENCE_NO: this.medicalCheckInputForm.LICENCE_NO,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          this.API_ResultContainerControl(res);
          if (res.data.severity === 1) {
            this.$notify({title: "Success", type: "success", text: "Succesfully Update"})
            this.$refs.pond.removeFile();
            this.$refs.pond2.removeFile();
            this.$refs.pond3.removeFile();
            this.$refs.pond4.removeFile();
            await this.inputTabDataClean();
            await this.getDataById(this.personCheckInputForm)
            await this.getAllDataByMail(this.user);
          }
          if (res.data.severity === 2) {
            this.$notify({title: "Error", type: "error", text: res.data.lastError})
          }
          if (res.data.severity === 3) {
            this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
          }
          this.$forceUpdate();
        } catch (e) {
          this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"});
        }
      }
      if (this.documentForm.documentTypeIndex == 5) {
        try {
          let res;
          if (Object.keys(this.personCheckInputForm.file).length !== 0) {
            res = await HRPersonelRequestService.UploadLandingInformationService({
              files: this.personCheckInputForm.file,
              DocumentIndeksNo: 1,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              ExpiryDate: this.landingInformationInputForm.expriyDate,

              // LANDING BİLGİLERİ GELECEK
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file2).length !== 0) {
            res = await HRPersonelRequestService.UploadLandingInformationService({
              files: this.personCheckInputForm.file2,
              DocumentIndeksNo: 2,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              ExpiryDate: this.landingInformationInputForm.expriyDate,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file3).length !== 0) {
            res = await HRPersonelRequestService.UploadLandingInformationService({
              files: this.personCheckInputForm.file3,
              DocumentIndeksNo: 3,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              ExpiryDate: this.landingInformationInputForm.expriyDate,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          await new Promise(r => setTimeout(r, 77));

          if (Object.keys(this.personCheckInputForm.file4).length !== 0) {
            res = await HRPersonelRequestService.UploadLandingInformationService({
              files: this.personCheckInputForm.file4,
              DocumentIndeksNo: 4,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              ExpiryDate: this.landingInformationInputForm.expriyDate,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          if (Object.keys(this.personCheckInputForm.file4).length === 0 && Object.keys(this.personCheckInputForm.file3).length === 0 && Object.keys(this.personCheckInputForm.file2).length === 0 && Object.keys(this.personCheckInputForm.file).length === 0) {
            res = await HRPersonelRequestService.UploadLandingInformationService({
              DocumentIndeksNo: 1,
              DocumentId: this.documentForm.Document_P_ID === '' ? -1 : this.documentForm.Document_P_ID,
              PersonelID: this.personInformation[0].ID === undefined ? -1 : this.personInformation[0].ID,
              Nefa_Employee_Id: this.personCheckInputForm.Nefa_Employee_Id,
              CompanyCode: this.personCheckInputForm.CompanyCode,
              ExpiryDate: this.landingInformationInputForm.expriyDate,
            });
            this.documentForm.Document_P_ID = res.data.jsondata;
          }
          this.API_ResultContainerControl(res);
          if (res.data.severity === 1) {
            this.$notify({title: "Success", type: "success", text: "Succesfully Update"})
            this.$refs.pond.removeFile();
            this.$refs.pond2.removeFile();
            this.$refs.pond3.removeFile();
            this.$refs.pond4.removeFile();
            await this.inputTabDataClean();
            await this.getDataById(this.personCheckInputForm)
            await this.getAllDataByMail(this.user);
          }
          if (res.data.severity === 2) {
            this.$notify({title: "Error", type: "error", text: res.data.lastError})
          }
          if (res.data.severity === 3) {
            this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
          }
          this.$forceUpdate();
        } catch (e) {
          this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"});
        }
      }
    },

    async tryDeleteDocument(documentForm) {
      await this.$swal({
        title: '<p style="text-align: center;font-size: 22px;">Do you want to delete document?</p>',
        html: "",
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#e55050',
        confirmButtonColor: '#186c81cc',
        confirmButtonText: 'Yes',
      }).then(async (response) => {
        if (response.value) {
          try {
            let res = this.$store.dispatch("HRPersonelRequest/DeleteDocument", documentForm)
            this.API_ResultContainerControl(res);
            await this.getDataById(this.personCheckInputForm)
            if (res.severity === 1) {
              this.$notify({
                title: "Success",
                text: "Document deleted.",
                type: "success"
              });
              this.tabIndex = null;
            }
            if (res.severity === 2) {
              this.$notify({title: "Error", type: "error", text: res.data.lastError})
            }
            if (res.severity === 3) {
              this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
            }
          } catch (e) {
            this.$notify({title: "Error", text: e.message, type: "error"});
          }
        }
      });
    },
    getFullImgUrl() {
      let url;
      if (this.documentForm.documentTypeID > 0) {
        url = this.getImageUrl + '/' + this.personCheckInputForm.Id + '/' + this.documentForm.documentTypeIndex + '/' + this.DocPID + '/' + this.fileExtension + '/' + this.personCheckInputForm.CompanyCode + '/' + this.personCheckInputForm.Nefa_Employee_Id + '/' + this.selectedIndex;
      } else {
        url = "";
      }
      this.globalImgUrl = url;
    },
    getFullPdfUrl() {
      let url;
      if (this.documentForm.documentTypeID > 0) {
        url = this.getPdfUrl + '/' + this.personCheckInputForm.Id + '/' + this.documentForm.documentTypeIndex + '/' + this.DocPID + '/' + this.fileExtension + '/' + this.personCheckInputForm.CompanyCode + '/' + this.personCheckInputForm.Nefa_Employee_Id + '/' + this.selectedIndex;
      } else {
        url = "";
      }
      this.globalPdfUrl = url;
    },
    async tryDeleteDocumentAttachments(form) {
      await this.$swal({
        title: '<p style="text-align: center;font-size: 22px;">Do you want to delete document?</p>',
        html: "",
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#e55050',
        confirmButtonColor: '#186c81cc',
        confirmButtonText: 'Yes',
      }).then(async (response) => {
        if (response.value) {
          try {
            let res = this.$store.dispatch("HRPersonelRequest/DeleteDocumentAttachments", form)
            this.API_ResultContainerControl(res);
            document.getElementById('close').click();
            this.inputTabDataClean();
            window.location.reload();
            await this.getDataById(this.personCheckInputForm)
            if (res.severity === 1) {
              this.$notify({
                title: "Success",
                text: "Document deleted.",
                type: "success"
              });
              this.tabIndex = null;

            }
            if (res.severity === 2) {
              this.$notify({title: "Error", type: "error", text: res.data.lastError})
            }
            if (res.severity === 3) {
              this.$notify({title: "Warning", type: "warning", text: res.data.lastError})
            }
          } catch (e) {
            this.$notify({title: "Error", text: e.message, type: "error"});
          }
        }
      });
    },
  },

  async created() {
    this.user = await JSON.parse(localStorage.getItem('user'))
    await this.getAllDataByMail(this.user);
    await this.changeDocumentTypeByID('General');
    await this.getCVLTypes();
    await this.getCountries();
    this.getUsersWithPerms();
    this.getDistinctedPositions();
  },

  watch: {
    multiSelectValue: {
      handler(values) {
        if (values !== "") this.medicalCheckInputForm.multiselectType = values.join(',');
      },
    }
  },
  mounted() {
    // this.TR2EN([]);
    //this.intervalFunc();
  },
  computed: {
    filteredData() {
      let filteredData = JSON.parse(JSON.stringify(this.TR2EN(this.personelList)));
      let text = '';
      if (this.search) {
        text = this.search.toUpperCase().replace('İ', 'I').replace('Ö', 'O').replace('Ü', 'U')
            .replace('Ş', 'S').replace('Ç', 'C').replace('Ğ', 'G')
        filteredData = filteredData.filter((row) => {
          return Object.values(row).some((value) => {
            return String(value).toUpperCase().includes(text.toUpperCase());
          });
        });
      }
      else if (this.searchTLC) {
    let tlcText = this.searchTLC.toUpperCase().replace('İ', 'I').replace('Ö', 'O').replace('Ü', 'U')
        .replace('Ş', 'S').replace('Ç', 'C').replace('Ğ', 'G');
    
    filteredData = filteredData.filter((row) => {
        return String(row.TLC).toUpperCase().includes(tlcText.toUpperCase());
    });
}
if (this.selectedValue !== 'Select') {
  console.log(this.selectedValue)
        switch (this.selectedValue) {
          case 'Pasaport':
            filteredData = filteredData.filter(row => row.STATPP === 3);
            break;
          case 'Visa':
            filteredData = filteredData.filter(row => row.STATVS === 3);
            break;
          case 'License':
            filteredData = filteredData.filter(row => row.STATLC === 3);
            break;
          case 'landing':
            filteredData = filteredData.filter(row => row.STATLD === 3);
            break;
          case 'Medical':
            filteredData = filteredData.filter(row => row.STATMC === 3);
            break;
          default:
            break;
        }
      }
      return filteredData;
    },
    // backgroundColor() {
    //   if (this.isActiveClass === "nav-link active") {
    //     return this.landingInformationInputForm.whoUpload !== 'CSP' ? "#56759c" : "#40e0d0";
    //   }
    //   return 'background-color: rgb(86, 117, 156); color: #fff;';
    // },

    permsUserFilteredData() {
      let filteredData = this.TR2EN(this.usersWithPerms);
      let text = '';
      if (this.userSearch) {
        text = this.userSearch.toUpperCase().replace('İ', 'I').replace('Ö', 'O').replace('Ü', 'U')
            .replace('Ş', 'S').replace('Ç', 'C').replace('Ğ', 'G')
        filteredData = filteredData.filter((row) => {
          return Object.values(row).some((value) => {
            return String(value).toUpperCase().includes(text.toUpperCase());
          });
        });
      }
      return filteredData;
    },
    permsDistinctedFilteredData() {
      let filteredData = this.TR2EN(this.distinctedPositions);
      let text = '';
      if (this.DistSearch) {
        text = this.DistSearch.toUpperCase().replace('İ', 'I').replace('Ö', 'O').replace('Ü', 'U')
            .replace('Ş', 'S').replace('Ç', 'C').replace('Ğ', 'G')
        filteredData = filteredData.filter((row) => {
          return Object.values(row).some((value) => {
            return String(value).toUpperCase().includes(text.toUpperCase());
          });
        });
      }
      return filteredData;
    }
  }
}
</script>
